import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import Header from './../layout/Header'; //Include Heder
import Footer from './../layout/Footer'; //Include Footer
import Select from 'react-select'
import Select2 from "react-select2-wrapper";
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { ErrorMessage, useFormik } from 'formik';

import Service from './../../service';
import AutoComplete from './../move/Autocomplete';
import { firebase, auth } from './../firebase.js';
// import Select from 'react-select';
import moment, { invalid } from 'moment-timezone';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import 'react-select/dist/css/react-select.css';


import SignatureCanvas from 'react-signature-canvas'
import toast, { Toaster } from 'react-hot-toast';
const api = new Service();
let verify;
let recaptchaWrapperRef;
let sigCanvas = {}
let eighteenYearsAgo = new Date();
eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

const RegisterB = (props) => {


  const navigate = useNavigate();
  const { service_type } = useParams()
  const [loading, setloading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [validNumber, setvalidNumber] = useState(false);
  // const [country, setcountry] = useState([]);
  const makeRequest = (values) => {
    setloading(true)
    api.postApiHelper('helper-signup', values).then(response => {
      setloading(false)
      if (response.data && response.data.is_verified == 0) {
        localStorage.setItem("user_token", response.data.web_auth_key);
        localStorage.setItem("user_type", 'helper');
        localStorage.setItem("user_detail", response.data);
        navigate('/helper-pending')
      }
    }).catch(error => {
      setloading(false)
      toast.error(error.message);
    });
  };

  // const [finishStatus, setfinishStatus] = useState(false);

  // const onBackButtonEvent = (e) => {
  //   e.preventDefault();
  //   if (!finishStatus) {
  //     if (window.confirm("Changes you made may not be saved ?")) {
  //       setfinishStatus(true)
  //       navigate('/helper-login')
  //     } else {
  //       window.history.pushState(null, null, window.location.pathname);
  //       setfinishStatus(false)
  //     }
  //   }
  // }

  // useEffect(() => {
  //   window.history.pushState(null, null, window.location.pathname);
  //   window.addEventListener('popstate', onBackButtonEvent);
  //   return () => {
  //     window.removeEventListener('popstate', onBackButtonEvent);
  //   };
  // }, []);

  const [data, setData] = useState({
    term_and_condition: false,
    first_name: "",
    last_name: "",
    email_id: "",
    checkEmail: "",
    password: "",
    dob: "",
    helper_address: "",
    helper_state: "",
    helper_city: "",
    helper_zipcode: "",
    service_type: service_type,
    helper_lat: "",
    helper_long: "",
    phone_num: "",
    vehicle_type_id: "",
    vehicle_year: "",
    plate_num: "",
    company_name: "",
    model: "",
    insurance_number: "",
    insurance_policy_expiry: "",
    insurance_photo: [],
    vehicle_image_url: [],
    question_data: [{
      question_id: 1,
      answer: "",
      addition_info: ""
    }, {
      question_id: 2,
      answer: "",
      addition_info: ""
    }, {
      question_id: 3,
      answer: "",
      addition_info: { zelle_account: "" }
    }, {
      question_id: 4,
      answer: "",
      addition_info: { name: "", email: "", phone: "" }
    }, {
      question_id: 5,
      answer: "",
      addition_info: ""
    }, {
      question_id: 6,
      answer: "",
      addition_info: ""
    }, {
      question_id: 7,
      answer: "",
      addition_info: ""
    }],
    question_optional_data: [{
      question_id: 1,
      answer: "",
      addition_info: ""
    }, {
      question_id: 2,
      answer: "",
      addition_info: ""
    }, {
      question_id: 3,
      answer: "",
      addition_info: ""
    },
    {
      question_id: 4,
      answer: "",
      addition_info: ""
    }],
    photo_url: "",
    helper_agreement: false,
    helper_signature: "",
    security_key: "",
    dial_code: "+1"
  });

  const handleNextStep = (newData, final = false) => {
    setData((prev) => ({ ...prev, ...newData }));
    if (final) {
      makeRequest(newData);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };
  const handlePrevStep = (newData) => {

    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };
  const steps = [];
  // steps.push(<Step next={handleNextStep} data={data} setData={setData} />)
  steps.push(<StepOne next={handleNextStep} prev={handlePrevStep} data={data} validNumber={validNumber} setvalidNumber={setvalidNumber} setloading={setloading} loading={loading} />)
  if (service_type == 1 || service_type == 3) {
    steps.push(<StepTwo next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} />)
  }
  steps.push(<StepThere next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} setData={setData} />)
  steps.push(<StepFour next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} setData={setData} />)
  steps.push(<StepFive next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} setData={setData} />)
  steps.push(<StepSix next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} setData={setData} />)
  steps.push(<StepSeven next={handleNextStep} prev={handlePrevStep} data={data} loading={loading} setloading={setloading} setData={setData} />)
  // steps.push(<StepEight next={handleNextStep} prev={handlePrevStep}  data={data} loading={loading} setloading={setloading}  setData={setData}  />)

  // back button for helper register
  // window.history.pushState(null, null, window.location.href);
  // window.onpopstate = function () {
  //   if (currentStep == 0) {
  //     navigate('/helper-service-type')
  //   }
  //   else {
  //     window.history.pushState(null, "on browser back click", setCurrentStep((prev) => prev - 1));
  //   }
  // };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Header />
      <main>
        <div className="ugf-wrapper helper-steppro">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-8">
                <div className="ufg-job-application-wrapper pt30">
                  <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                      <span className="step-text"> <span className="current-step">{currentStep + 1}</span> of <span className="total-step"></span> {steps.length} Step</span>
                    </div>
                  </div>

                  <div className="App">
                    {steps[currentStep]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer loading={loading} />
    </>
  )
}

const Step = (props) => {

  const SelectServiceType = (e) => {
    props.data.service_type = e;
    props.setData(props.data);
    props.next(props.data);
  }

  return (
    <>
      <div className="form-steps" style={{ display: "block" }}>
        <h5>Select how you want to work with us</h5>
        <form action="#" className="job-application-form login-page row">
          <div className="row no-gutters d-flex align-items justify-content-center" autoComplete="off">
            <div className="col-6 col-sm-6 col-lg-6 mb-2" onClick={() => props.selectServiceType(1)}>
              <input className="checkbox-tools" type="radio" name="tools" id="tool-1" value="" />
              <label className="for-checkbox-tools" htmlFor="tool-1">
                <div className="cardbox">
                  <img alt="" src="/web/img/move-it-pros.jpg" />
                  <h5>Move It Pro</h5>
                  <h6>Earn up to $45+/hr</h6>
                  <p>I have a pickup truck, cargo, box truck, or a vehicle with a trailer and can lift over 80 lbs</p>
                </div>
              </label>
            </div>
            <div className="col-6 col-sm-6 col-lg-6 mb-2" onClick={() => SelectServiceType(2)}>
              <input className="checkbox-tools" type="radio" name="tools" id="tool-2" value="" />
              <label className="for-checkbox-tools" htmlFor="tool-2">
                <div className="cardbox">
                  <img alt="" src="/web/img/heper-bgmoveit.jpg" />
                  <h5>Move It Muscle</h5>
                  <h6>Earn up to $25+/hr</h6>
                  <p>I don't have a pickup truck but can lift over 80 lbs to assist Move It Pros or jobs that need only muscle</p>
                </div>
              </label>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 mb-2" onClick={() => SelectServiceType(3)}>
              <input className="checkbox-tools" type="radio" name="tools" id="tool-3" value="" />
              <label className="for-checkbox-tools" htmlFor="tool-3">
                <div className="cardbox">
                  <img alt="" src="/web/img/moveit-muscle-pro-both.jpg" className="prp-misclimg" />
                  <h5>Move It Pro & Muscle</h5>
                  <h6></h6>
                  <p>I have a pickup truck, cargo, box truck, or a vehicle with but can lift over 80 lbs to assist Move It Pros or jobs</p>
                </div>
              </label>
            </div>
          </div>
        </form>
      </div>
    </>

  )

}
const StepOne = (props) => {

  const [show, setShow] = useState(false);
  const [helperCountryPopup, sethelperCountryPopup] = useState(false);
  const [OTP, setOTP] = useState('');
  const [final, setfinal] = useState('');
  const [startDate, setStartDate] = useState(props.data.dob ? props.data.dob : '');
  const [country, setcountry] = useState([]);

  useEffect(() => {
    getCountry()
  }, [])
  const getCountry = () => {
    api.getApi('get-country').then(response => {
      setcountry(response);
    }).catch(error => {
    });
  }

  const oneStepform = useFormik({
    initialValues: props.data,
    validationSchema: yup.object({
      first_name: yup.string().max(25, 'User can enter max 25 characters').required('Please enter your first name.'),
      last_name: yup.string().max(25, 'User can enter max 25 characters').required('Please enter your last name.'),
      email_id: yup.string().email('Invalid email address.').required('Please enter your email address.'),
      password: yup.string().required('Password enter password.'),
      dob: yup.string().required('Please select your birth of date.')
        .test("DOB", "Please choose a valid date of birth", (value) => {
          return moment().diff(moment(value), "years") >= 18;
        }).nullable(),
      helper_address: yup.string().required('Please enter your valid addres.'),
      helper_city: yup.string().required('Please enter your city name.'),
      helper_state: yup.string().required('Please enter your state name.'),
      helper_zipcode: yup.string().required('Please enter your zipcode.'),
      phone_num: yup.number().typeError('You must specify a number.').required('Please enter your phone number.'),
      term_and_condition: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      checkEmail: yup.boolean(),
      dial_code: yup.string().required('Please select your country.'),
    }),
    onSubmit: values => {
      values.phone_num = values.dial_code + ' ' + values.phone_num;
      props.next(values)
    }
  });

  const setHelperAddress = e => {
    oneStepform.setFieldValue('helper_address', e.formatted_address);
    oneStepform.setFieldValue('helper_lat', e.geometry.location.lat());
    oneStepform.setFieldValue('helper_long', e.geometry.location.lng());
    for (let component of e.address_components) {
      // console.log(component)
      // @ts-ignore remove once typings fixed
      let componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          // address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          // address1 += component.short_name;
          break;
        }

        case "postal_code": {
          oneStepform.setFieldValue('helper_zipcode', component.long_name);
          break;
        }

        case "postal_code_suffix": {
          // postcode = `${postcode}-${component.long_name}`;
          break;
        }

        case "locality":
          oneStepform.setFieldValue('helper_city', component.long_name);
          break;

        case "administrative_area_level_1": {
          oneStepform.setFieldValue('helper_state', component.long_name);
          break;
        }

        case "country":
          // oneStepform.setFieldValue('helper_state', component.long_name);
          break;
      }
    }
  }

  const checkEmailExist = (email_id) => {
    oneStepform.setFieldValue('email_id', email_id)
    api.postApiHelper('check-helper-email-address', { email_id: email_id }).then(response => {
      if (response) {
        oneStepform.setFieldValue('checkEmail', response)
      } else {
        oneStepform.setFieldValue('checkEmail', false)
      }
      return response;
    }).catch(error => {
      oneStepform.setFieldValue('checkEmail', false)
    });
  }

  const finalSubmit = (event) => {
    event.preventDefault();

    if (oneStepform.isValid) {
      props.setloading(true);
      api.postApiHelper('check-email-address', { email_id: oneStepform.values.email_id }).then(response => {
        if (response) {
          oneStepform.setFieldValue('checkEmail', response)
        } else {
          if (oneStepform.isValid && oneStepform.values.phone_num && props.validNumber == false) {
            sentOTP();
          } else {
            props.setloading(false);
            oneStepform.handleSubmit();
          }
        }
      }).catch(error => {
        if (oneStepform.isValid && oneStepform.values.phone_num && props.validNumber == false) {
          sentOTP();
        } else {
          props.setloading(false);
          oneStepform.handleSubmit();
        }
      });
    } else {
      props.setloading(false);
      oneStepform.handleSubmit();
    }
  }

  const sentOTP = () => {
    props.setloading(true);
    if (verify && recaptchaWrapperRef) {
      verify.clear()
      recaptchaWrapperRef.innerHTML = `<div id="recaptcha-container"></div>`
    }
    verify = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      'size': 'invisible'
    });
    auth.signInWithPhoneNumber('+' + oneStepform.values.dial_code + oneStepform.values.phone_num, verify).then((result) => {
      setfinal(result);
      setShow(true);
      props.setloading(false);
    }).catch((err) => {
      props.setloading(false);
      toast.error("Please enter valid phone number.");
    });
  }

  const ValidateOtp = () => {
    if (formik3.isValid && formik3.values.OTP) {
      if (final == null)
        return;
      props.setloading(true);
      final.confirm(formik3.values.OTP).then((result) => {
        props.setvalidNumber(true);
        props.setloading(false);
        oneStepform.handleSubmit();
      }).catch((err) => {
        props.setloading(false);
        if (err) {
          formik3.setFieldError('OTP', 'Please enter a valid OTP.');
        }
      })
    } else {
      formik3.handleSubmit();
    }
  }

  const setPhoneNumber = (e) => {
    oneStepform.setFieldValue('phone_num', e.target.value)
    props.setvalidNumber(false);
  }

  const formik3 = useFormik({

    initialValues: {
      OTP: ''
    },

    validationSchema: yup.object({
      OTP: yup.string().required('Please enter a valid OTP.'),
    }),
    onSubmit: values => {
      ValidateOtp()
    }

  });

  const changeCountryValue = (event) => {
    if (event.target.value == '+1' || event.target.value == '+91') {
      sethelperCountryPopup(false);
      oneStepform.setFieldValue('dial_code', event.target.value)
    } else {
      sethelperCountryPopup(true)
    }
  }



  return (
    <>
      <div className="form-steps" style={{ display: "block" }}>

        {props.data.service_type == 1 ?
          <>
            <h3 className="border-bottom">Move It Pro</h3>
            <p>We are looking for honest, friendly, motivated, hard working, able-bodied individuals with a pick-up truck, cargo van, box truck, or a vehicle w/a trailer to help move and deliver.</p>
          </>
          : ''}

        {props.data.service_type == 2 ?
          <>
            <h3 className="border-bottom">Move It Muscle</h3>
            <p>We are looking for honest, friendly, motivated, hard working, able-bodied individuals to assist Move It Pros or jobs that only need muscle. </p>
          </>
          : ''}

        {props.data.service_type == 3 ?
          <>
            <h3 className="border-bottom">Move It Pro and Muscle</h3>
            <p>We are looking for honest, friendly, motivated, hard working, able-bodied individuals with a pick-up truck, cargo van, box truck, or a vehicle w/a trailer to help move and deliver.</p>
          </>
          : ''}

        <p><b>Please fill in your information to start your application</b></p>
        <form className="job-application-form login-page row check-helper" onSubmit={oneStepform.handleSubmit} autoComplete="off">
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-user fa-fw"></i>
            <input type="text" name="first_name" autoComplete="off" {...oneStepform.getFieldProps("first_name")} />
            <span>First Name</span>
            {oneStepform.touched.first_name && oneStepform.errors.first_name ? <div className="text-danger">{oneStepform.errors.first_name}</div> : ''}
          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-user fa-fw"></i>
            <input type="text" name="last_name" autoComplete="off" {...oneStepform.getFieldProps("last_name")} />
            <span>Last Name</span>
            {oneStepform.touched.last_name && oneStepform.errors.last_name ? <div className="text-danger">{oneStepform.errors.last_name}</div> : ''}
          </div>
          <div className="form-row col-md-12 col-lg-12">
            <i className="fas fa-envelope"></i>
            <input type="text" name="email_id" autoComplete="off" onBlur={(e) => checkEmailExist(e.target.value)} />
            <span>Email Address</span>
            {oneStepform.touched.email_id && oneStepform.errors.email_id ? <div className="text-danger">{oneStepform.errors.email_id}</div> : ''}
            {oneStepform.values.checkEmail ? <div className="text-danger">Email already exists</div> : null}

          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-lock fa-fw"></i>
            <input type="password" name="password" autoComplete="new-password" {...oneStepform.getFieldProps("password")} />
            <span>Password</span>
            {oneStepform.touched.password && oneStepform.errors.password ? <div className="text-danger">{oneStepform.errors.password}</div> : ''}
          </div>

          <div className="form-row col-md-6 col-lg-6">
            <div className="helperwidth phonecountry mt-0">
              <div className="select-input">
                <select className="select-text" name="dial_code" value={oneStepform.values.dial_code} onChange={(e) => changeCountryValue(e)}>
                  <option className="option-margin" value="">Select</option>
                  {country.length > 0 && country.map((option, index) => (
                    <option className="option-margin" value={option.id} key={index} >{option.text}</option>
                  ))}
                </select>
                {oneStepform.touched.dial_code && oneStepform.errors.dial_code ? <span className="text-danger">{oneStepform.errors.dial_code}</span> : null}
                <label className="select-label">Select Country</label>
              </div>
            </div>
          </div>



          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-mobile fa-fw"></i>
            <input type="text" name="phone_num" autoComplete="off" value={oneStepform.values.phone_num} onChange={(e) => setPhoneNumber(e)} />
            <span>Mobile</span>
            {oneStepform.touched.phone_num && oneStepform.errors.phone_num ? <div className="text-danger">{oneStepform.errors.phone_num}</div> : ''}
          </div>
          <div className="form-row col-md-6 col-lg-6 datepicks">
            <i className="fas fa-calendar fa-fw z1"></i>
            <DatePicker selected={oneStepform.values.dob} onChange={(date) => oneStepform.setFieldValue('dob', date)} maxDate={eighteenYearsAgo} dropdownMode="select" showYearDropdown adjustDateOnChange />
            <span>Select DOB</span>
            {/*<input type="date" id="datepicker" autoComplete="off"  name="dob"  {...oneStepform.getFieldProps("dob")} />*/}
            {oneStepform.touched.dob && oneStepform.errors.dob ? <div className="text-danger">{oneStepform.errors.dob}</div> : ''}
          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-map-marker-alt"></i>
            <AutoComplete addplace={setHelperAddress} type="registration" value={oneStepform.values.helper_address} />
            <span>Address</span>
            {oneStepform.touched.helper_address && oneStepform.errors.helper_address ? <div className="text-danger">{oneStepform.errors.helper_address}</div> : ''}
          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-location-arrow"></i>
            <input type="text" name="helper_state" autoComplete="off"  {...oneStepform.getFieldProps("helper_state")} />
            <span>State</span>
            {oneStepform.touched.helper_state && oneStepform.errors.helper_state ? <div className="text-danger">{oneStepform.errors.helper_state}</div> : ''}
          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-map-marked-alt"></i>
            <input type="text" name="helper_city" autoComplete="off" {...oneStepform.getFieldProps("helper_city")} />
            <span>City</span>
            {oneStepform.touched.helper_city && oneStepform.errors.helper_city ? <div className="text-danger">{oneStepform.errors.helper_city}</div> : ''}

          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-map-pin"></i>
            <input type="text" name="helper_zipcode" autoComplete="off" {...oneStepform.getFieldProps("helper_zipcode")} />
            <span>Zip Code</span>
            {oneStepform.touched.helper_zipcode && oneStepform.errors.helper_zipcode ? <div className="text-danger">{oneStepform.errors.helper_zipcode}</div> : ''}
          </div>



          <div className="form-group check-group col-md-12 col-lg-12">
            <div className="custom-checkbox">
              <input type="checkbox" className="custom-control-input" id="customControlValidation14" name="term_and_condition"   {...oneStepform.getFieldProps("term_and_condition")} checked={oneStepform.values.term_and_condition} />
              <label className="custom-control-label" htmlFor="customControlValidation14"> By clicking on sign up button you agree to our <Link to="/terms-condition" className="pnk-txt" target="_blank">Terms & Conditions</Link> and
                {oneStepform.touched.term_and_condition && oneStepform.errors.term_and_condition ? <div className="text-danger">{oneStepform.errors.term_and_condition}</div> : ''}</label>
            </div>
          </div>

          <div ref={ref => recaptchaWrapperRef = ref}>

            <div id="recaptcha-container"></div>
          </div>

          <div className="col-md-12">
            <button className="btn step-btn mt-3" type="button" onClick={(e) => finalSubmit(e)} disabled={props.loading}> <span>Continue</span></button>
          </div>
        </form>
      </div>
      <div className={show ? "modal display-block" : "modal display-none"} id="otp-model" tabIndex="-1" role="dialog" aria-labelledby="def" aria-hidden="true">
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="myModalLabel2">Enter OTP</h4>
              <button type="button" className="close" onClick={() => setShow(false)} ><span aria-hidden="true" onClick={() => setShow(false)} >&times;</span></button>
            </div>
            <div className="modal-body">
              <form className="login-page" onSubmit={formik3.handleSubmit} autoComplete="off">
                <p className="mb-0 f-14">Please enter the OTP sent on your mobile phone number.</p>
                <div className="form-row">
                  <i className="fa fa-phone"></i>
                  <input type="text" name="OTP" {...formik3.getFieldProps("OTP")} />

                </div>
                {formik3.touched.OTP && formik3.errors.OTP ? <div className="text-danger">{formik3.errors.OTP}</div> : null}
                {/* {invalidOTP &&
            				<>
            				 <div  className="text-danger">{invalidOTP}</div>
            				</>
                     } */}
                {/* {invalidOTP == '' && <div>{formik3.errors.OTP}</div>} */}

                {/*<div className="form-row"></div>
				<div className="forgot-password f-14">We need your phone number so we can give updates on your moves</div>
				 
				 <div className="forgot-password f-16">
				 <br></br> Not Recevied OTP <Link  to="" >Resend OTP</Link> </div>*/}

                <div className="form-row">
                  <button className="full" type="button" onClick={ValidateOtp} ><span>Sign Up</span></button>
                </div>

              </form>

            </div>
          </div>
        </div>
      </div>

      <div className={helperCountryPopup ? "modal display-block" : "modal display-none"} id="helperCountryPopup-model" tabIndex="-1" role="dialog" aria-labelledby="def" aria-hidden="true">
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header" style={{ background: "#ff95a2" }}>
              <h4 className="modal-title" style={{ textAlign: "center", width: "100%", color: "white" }}>Location Alert!</h4>
              <button type="button" className="close" onClick={() => sethelperCountryPopup(false)} ><span aria-hidden="true" onClick={() => sethelperCountryPopup(false)} >&times;</span></button>
            </div>
            <div className="modal-body">
              <div>
                <p>Thank you for interest in Move It. We currently serve Las Vegas, San Diego, Tucson, Phoenix & Denver.
                </p>
                <p>If you don’t see your city, please email us by clicking below and we will reach out when we are available in your area.</p>


                <p className="mb-0">Move It Support

                </p>
                <p className="contact-right"><a href="mailto:helpers@gomoveit.com" target="_blank"> helpers@gomoveit.com</a></p>

              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const StepTwo = (props) => {

  // useEffect(() => {
  //     if(service_type==2) {
  //       props.next(props.data)
  //     }
  // }, [])

  const formik = useFormik({
    initialValues: props.data,
    validationSchema: yup.object({
      vehicle_type_id: yup.string().required('Please select vehicle type '),
      vehicle_year: yup.number().typeError('You must specify a number').required('Please select vehicle year'),
      plate_num: yup.string().required('Please enter vehicle plate number '),
      company_name: yup.string().required('Please enter vehicle company name '),
      model: yup.string().required('Please enter vehicle model number '),
      insurance_number: yup.string().required('Please enter vehicle insurance number '),
      insurance_policy_expiry: yup.string().required('Please select vehicle insurance expiry date '),
      insurance_photo: yup.array().min(1, 'Please upload atleast one image of the insurance.'),
      vehicle_image_url: yup.array().min(4, 'Your need to upload your vehicle front, left side, right side and back side photos.')
    }),
    onSubmit: values => {
      props.next(values)
    }
  });


  const updateInsurancePhoto = (e, index) => {
    const filesSelected = Array.from(e.target.files);
        const validSelectedFiles = filesSelected.filter((file) =>
        ['image/png', 'image/gif', 'image/jpeg'].includes(file.type)
        );

        if (validSelectedFiles.length !== filesSelected.length) {
            toast.error('Some files are not valid. Only PNG, GIF, and JPEG are allowed.');
        } else {
          let totalFiles = e.target.files.length
          if (totalFiles < 4) {
            props.setloading(true);
            var formData = new FormData();
            for (let i = 0; i < e.target.files.length; i++) {
              formData.append('image[]', e.target.files[i])
            }
            formData.append("folder_name", 'helper_insurance_photo');
            api.postApi('upload-images', formData, true).then(response => {
              formik.setFieldValue(`insurance_photo.${index}`, response.data[0]);
              props.setloading(false);
            }).catch(error => {
              props.props.setloading(false);
              toast.error(error.message);
            });
          }
        }
  }

  const updateVehiclePhoto = (e, index) => {
    const filesSelected = Array.from(e.target.files);
    const validSelectedFiles = filesSelected.filter((file) =>
    ['image/png', 'image/gif', 'image/jpeg'].includes(file.type)
    );

    if (validSelectedFiles.length !== filesSelected.length) {
        toast.error('Some files are not valid. Only PNG, GIF, and JPEG are allowed.');
    } else {
      let totalFiles = e.target.files.length
      if (totalFiles < 4) {
        props.setloading(true);
        var formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
          formData.append('image[]', e.target.files[i])
        }
        formData.append("folder_name", 'vehicle_image');
        api.postApi('upload-images', formData, true).then(response => {
          formik.setFieldValue(`vehicle_image_url.${index}`, response.data[0]);
          props.setloading(false);
        }).catch(error => {
          props.setloading(false);
          toast.error(error.message);
        });
      }
    }
  }

  return (
    <div className="form-steps" style={{ display: "block" }}>
      <h3 className="border-bottom">Add Vehicle Information</h3>
      <h5>What is the year, make, and model of your vehicle?</h5>
      <p>You must have a pickup truck, cargo van, box truck, or vehicle w/a trailer to become a Move It Pro.</p>
      <form action="#" className="job-application-form login-page row" onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="form-row col-md-6 col-lg-6">
          <div className="select-input">
            <select className="select-text" name="vehicle_type_id" {...formik.getFieldProps("vehicle_type_id")}>
              <option value="" >Select Vehicle Type</option>
              <option value="1">Pickup truck</option>
              <option value="2">Cargo van</option>
              <option value="3">Box truck</option>
              <option value="4">Vehicle w/a trailer</option>
            </select>
            <label className="select-label">Vehicle Type</label>
          </div>
          {formik.touched.vehicle_type_id && formik.errors.vehicle_type_id ? <div className="text-danger">{formik.errors.vehicle_type_id}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6">
          <div className="select-input">
            <select className="select-text" name="vehicle_year" {...formik.getFieldProps("vehicle_year")}>
              <option value="" >Select Vehicle Year</option>
              <option value="1990" >1990</option>
              <option value="1991">1991</option>
              <option value="1992">1992</option>
              <option value="1993">1993</option>
              <option value="1994">1994</option>
              <option value="1995">1995</option>
              <option value="1996">1996</option>
              <option value="1997">1997</option>
              <option value="1998">1998</option>
              <option value="1999">1999</option>
              <option value="2000">2000</option>
              <option value="2001">2001</option>
              <option value="2002">2002</option>
              <option value="2003">2003</option>
              <option value="2004">2004</option>
              <option value="2005">2005</option>
              <option value="2006">2006</option>
              <option value="2007">2007</option>
              <option value="2008">2008</option>
              <option value="2009">2009</option>
              <option value="2010">2010</option>
              <option value="2011">2011</option>
              <option value="2012">2012</option>
              <option value="2013">2013</option>
              <option value="2014">2014</option>
              <option value="2015">2015</option>
              <option value="2016">2016</option>
              <option value="2017">2017</option>
              <option value="2018">2018</option>
              <option value="2019">2019</option>
              <option value="2020">2020</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </select>
            <label className="select-label">Vehicle Year</label>
          </div>
          {formik.touched.vehicle_year && formik.errors.vehicle_year ? <div className="text-danger">{formik.errors.vehicle_year}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6">
          <i className="fas fa-truck-pickup"></i>
          <input type="text" name="plate_num" {...formik.getFieldProps("plate_num")} />
          <span>Vechicle Plate Number</span>
          {formik.touched.plate_num && formik.errors.plate_num ? <div className="text-danger">{formik.errors.plate_num}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6">
          <i className="fas fa-peace fa-fw"></i>
          <input type="text" name="company_name" {...formik.getFieldProps("company_name")} />
          <span>Vehicle Make</span>
          {formik.touched.company_name && formik.errors.company_name ? <div className="text-danger">{formik.errors.company_name}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6">
          <i className="fas fa-truck-pickup"></i>
          <input type="text" name="model" {...formik.getFieldProps("model")} />
          <span>Vehicle Model</span>
          {formik.touched.model && formik.errors.model ? <div className="text-danger">{formik.errors.model}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6">
          <i className="fas fa-file fa-fw"></i>
          <input type="text" name="insurance_number" {...formik.getFieldProps("insurance_number")} />
          <span>Insurance Policy Number</span>
          {formik.touched.insurance_number && formik.errors.insurance_number ? <div className="text-danger">{formik.errors.insurance_number}</div> : ''}
        </div>
        <div className="form-row col-md-6 col-lg-6 datepicks">
          <i className="fas fa-calendar fa-fw z1"></i>

          <DatePicker selected={formik.values.insurance_policy_expiry} onChange={(date) => formik.setFieldValue('insurance_policy_expiry', date)} minDate={new Date()} dropdownMode="select" showYearDropdown adjustDateOnChange />
          <span>Policy Expiry Date</span>
          {formik.touched.insurance_policy_expiry && formik.errors.insurance_policy_expiry ? <div className="text-danger">{formik.errors.insurance_policy_expiry}</div> : ''}
        </div>

        <div className="col-md-12">
          <h6 className="caseuper">Upload Insurance policy photo</h6>
        </div>
        <div className="form-row col-md-12 col-lg-12">
          {formik.values.insurance_photo.length > 0 && formik.values.insurance_photo.map((option, index) => (
            <div className="wrap-custom-file insurnaceupload-edit" key={index}>

              <div className="avatar-edit">
                <input type="file" id={'imageUpload_insurance' + index} accept=".png, .jpg, .jpeg" onChange={(e) => updateInsurancePhoto(e, index)} />
                <label htmlFor={'imageUpload_insurance' + index}></label>
              </div>

              <div className="avatar-preview">
                <div style={{ backgroundImage: "url(" + option + ")" }}></div>
              </div>
            </div>
          ))}
          {3 - formik.values.insurance_photo.length > 0 && Array.from(Array(3 - formik.values.insurance_photo.length), (e, i) => {
            return <div className="wrap-custom-file" key={i}>
              <input type="file" id={'insurenace_imageUpload_' + i} accept=".png, .jpg, .jpeg" onChange={(s) => updateInsurancePhoto(s, formik.values.insurance_photo.length)} />
              <label htmlFor={'insurenace_imageUpload_' + i} >
                <span>Upload Insurance Policy Photo</span>
                <i className="fa fa-plus-circle pluicon"></i>
              </label>
            </div>
          })}
        </div>
        {formik.touched.insurance_photo && formik.errors.insurance_photo ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.insurance_photo}</div> : ''}

        <div className="col-md-12">
          <h6 className="caseuper">Take Photo of Your Vehicle Photo's</h6>
        </div>
        <div className="form-row col-md-12 col-lg-12">
          {formik.values.vehicle_image_url.length > 0 && formik.values.vehicle_image_url.map((option, index) => (
            <div className="wrap-custom-file insurnaceupload-edit" key={index}>
              <div className="avatar-edit">
                <input type="file" id={'imageUpload_vehicle' + index} accept=".png, .jpg, .jpeg" onChange={(e) => updateVehiclePhoto(e, index)} />
                <label htmlFor={'imageUpload_insurance' + index}></label>
              </div>

              <div className="avatar-preview">
                <div style={{ backgroundImage: "url(" + option + ")" }}></div>
              </div>
            </div>
          ))}
          {4 - formik.values.vehicle_image_url.length > 0 && Array.from(Array(4 - formik.values.vehicle_image_url.length), (e, i) => {
            return <div className="wrap-custom-file" key={i}>
              <input type="file" id={'vehicle_photo_imageUpload_' + i} accept=".png, .jpg, .jpeg" onChange={(s) => updateVehiclePhoto(s, formik.values.vehicle_image_url.length)} />
              <label htmlFor={'vehicle_photo_imageUpload_' + i}>
                <span>Upload  Vehicle Photo</span>
                <i className="fa fa-plus-circle pluicon"></i>
              </label>
            </div>
          })}
        </div>
        {formik.touched.vehicle_image_url && formik.errors.vehicle_image_url ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.vehicle_image_url}</div> : ''}

        <div className="col-md-12">
          <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
            <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
          <button className="btn step-btn" type="submit" disabled={props.loading}><span>Continue</span></button>
        </div>
      </form>
    </div>

  )
}

const StepThere = (props) => {

  const [cities, setcities] = useState([]);
  const [ZelleID, setZelleID] = useState(props.data.question_data[3].answer == 'Yes' ? true : false);
  const [firendInfo, setfirendInfo] = useState(props.data.question_data[4].answer == 'Yes' ? true : false);

  useEffect(() => {
    GetCities();
  }, [])
  const GetCities = () => {
    // props.setLoading(true);
    api.getApi('get-cities').then(response => {
      setcities(response);
      // props.setLoading(false); 
    }).catch(error => {
      // props.setLoading(false);
      toast.error(error.message);
    });
  }


  const formik = useFormik({
    initialValues: {
      first_value: props.data.question_data[0].answer,
      second_value: props.data.question_data[1].answer,
      third_value: props.data.question_data[2].answer,
      fourth_value: props.data.question_data[3].answer,
      fifth_value: props.data.question_data[4].answer,
      six_value: props.data.question_data[5].answer,
      seven_value: props.data.question_data[6].answer,
      zelle_account: props.data.question_data[3].addition_info.zelle_account,
      name: props.data.question_data[4].addition_info.name,
      email: props.data.question_data[4].addition_info.email,
      phone: props.data.question_data[4].addition_info.phone

    },
    validationSchema: yup.object({
      first_value: yup.string().required('Please select working area.'),
      second_value: yup.string().required('Please select answer of question 2.'),
      third_value: yup.string().required('Please select answer of question 3. '),
      fourth_value: yup.string().required('Please select answer of question 4 '),
      zelle_account: ZelleID ? yup.string().required('Please enter zelle account Id. ') : yup.string(),
      fifth_value: yup.string().required('Please select answer of question 5 '),
      name: firendInfo ? yup.string().required('Please enter friend name.') : yup.string(),
      email: firendInfo ? yup.string().email('Invalid email address.').required('Please enter friend email. ') : yup.string(),
      phone: firendInfo ? yup.string().typeError('You must specify a number').required('Please enter friend mobile no.') : yup.string(),
      six_value: yup.string().required('Please select your t-shirt size.'),
      seven_value: yup.string().required('Please write something.')
    }),
    onSubmit: values => {
      props.next(props.data)
    }
  });

  const setQuestionValue = (index, event = '') => {
    if (index == 0 && event) {
      formik.setFieldValue('first_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 1 && event) {
      formik.setFieldValue('second_value', event.target.value);
      // let newArr = [...props.data.question_data]; // copying the old datas array
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 2 && event) {
      formik.setFieldValue('third_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 3 && event) {
      formik.setFieldValue('fourth_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
      if (event.target.value == 'Yes') {
        setZelleID(true)
      } else {
        props.data.question_data[index].addition_info = {};
        props.setData(props.data);
        setZelleID(false)
        formik.setFieldValue('zelle_account', '');
      }
    }

    else if (index == 4 && event) {
      formik.setFieldValue('fifth_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
      if (event.target.value == 'Yes') {
        setfirendInfo(true)
      } else {
        props.data.question_data[index].addition_info = {};
        props.setData(props.data);
        setfirendInfo(false)
        formik.setFieldValue('name', '');
        formik.setFieldValue('email', '');
        formik.setFieldValue('phone', '');
      }
    }

    else if (index == 5 && event) {
      formik.setFieldValue('six_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 6 && event) {
      formik.setFieldValue('seven_value', event.target.value);
      props.data.question_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

  }

  const setZellAccountValue = (e) => {
    formik.setFieldValue('zelle_account', e.target.value);
    props.data.question_data[3].addition_info = { "zelle_account": e.target.value };
  }

  const setFriendValue = (e, type) => {
    formik.setFieldValue(type, e.target.value);
    if (type == 'name') {
      props.data.question_data[4].addition_info = { ...props.data.question_data[4].addition_info, name: e.target.value };
    }
    if (type == 'email') {
      props.data.question_data[4].addition_info = { ...props.data.question_data[4].addition_info, email: e.target.value };
    }
    if (type == 'phone') {
      props.data.question_data[4].addition_info = { ...props.data.question_data[4].addition_info, phone: e.target.value };
    }
  }

  return (
    <div className="form-steps" style={{ display: "block" }}>
      <h3 className="border-bottom">More Information</h3>

      <form action="#" className="job-application-form" onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="row login-page mtb-0">
          <div className="form-row col-md-12 col-lg-12 mb-0">
            <p className="mtb-0">Which metropolitan area do you want to work in?</p>
          </div>
        </div>
        <div className="row login-page mtb-0">
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-truck-pickup"></i>
            <select onChange={(e) => setQuestionValue(0, e)} value={formik.values.first_value}>
              <option value="">Select</option>
              {cities.length > 0 && cities.map((option, index) => (
                <option value={option.city_id} key={index} >{option.name}</option>
              ))}
            </select>
            {formik.touched.first_value && formik.errors.first_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.first_value}</div> : ''}
          </div>

        </div>

        <div className="row login-page mtb-0">
          <div className="form-row col-md-12 col-lg-12 linebtween">
            <p className="mb-0">Do you have an iPhone or Android smartphone with GPS that can support the Move It App?</p>
            <div className="col-md-12">
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_1" className="custom-control-input" id="radio211" value="Yes" onChange={(e) => setQuestionValue(1, e)} checked={formik.values.second_value == 'Yes'} />
                  <label className="custom-control-label" htmlFor="radio211">Yes</label>
                </div>
              </div>
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_1" className="custom-control-input" id="radio212" value="No" onChange={(e) => setQuestionValue(1, e)} checked={formik.values.second_value == 'No'} />
                  <label className="custom-control-label" htmlFor="radio212">No</label>
                </div>
              </div>

            </div>
            {formik.touched.second_value && formik.errors.second_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.second_value}</div> : ''}
          </div>
          <div className="form-row col-md-12 col-lg-12 linebtween">
            <p className="mb-0">Are you able to lift 80 lbs over your head, and are you willing to lift and carry large, bulky items such as couches and desks?</p>
            <div className="col-md-12">
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_2" className="custom-control-input" id="radio213" value="Yes" onChange={(e) => setQuestionValue(2, e)} checked={formik.values.third_value == 'Yes'} />
                  <label className="custom-control-label" htmlFor="radio213">Yes</label>
                </div>
              </div>
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_2" className="custom-control-input" id="radio214" value="No" onChange={(e) => setQuestionValue(2, e)} checked={formik.values.third_value == 'No'} />
                  <label className="custom-control-label" htmlFor="radio214">No</label>
                </div>
              </div>
            </div>
            {formik.touched.third_value && formik.errors.third_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.third_value}</div> : ''}
          </div>
          <div className="form-row col-md-12 col-lg-12 linebtween">
            <p className="mb-0">
              Are you able to be paid weekly via direct deposit into your Zelle account? <br />
              Zelle is the one and only way Move It Pays helpers You must have or get a Zelle Account.
            </p>
            <div className="col-md-12">
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_3" className="custom-control-input" id="radio215" value="Yes" onChange={(e) => setQuestionValue(3, e)} checked={formik.values.fourth_value == 'Yes'} />
                  <label className="custom-control-label" htmlFor="radio215">Yes</label>
                </div>
              </div>
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_3" className="custom-control-input" id="radio216" value="No" onChange={(e) => setQuestionValue(3, e)} checked={formik.values.fourth_value == 'No'} />
                  <label className="custom-control-label" htmlFor="radio216">No</label>
                </div>
              </div>
            </div>
            {ZelleID ?


              <div className="row login-page mtb-0">
                <div className="form-row col-md-12 col-lg-12">

                  <input type="text" className="pl-15" onChange={(e) => setZellAccountValue(e)} value={formik.values.zelle_account} />
                  <span>Zelle Account Id</span>
                </div>
              </div>


              : ''}
            {formik.touched.zelle_account && formik.errors.zelle_account ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.zelle_account}</div> : ''}
            {formik.touched.fourth_value && formik.errors.fourth_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.fourth_value}</div> : ''}
          </div>
          <div className="form-row col-md-12 col-lg-12 linebtween">
            <p className="mb-0">Do you have a friend or family member who would like to work with you on two-person Moves?</p>
            <div className="col-md-12">
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_4" className="custom-control-input" id="radio217" value="Yes" onChange={(e) => setQuestionValue(4, e)} checked={formik.values.fifth_value == 'Yes'} />
                  <label className="custom-control-label" htmlFor="radio217">Yes</label>
                </div>
              </div>
              <div className="form-group radio-group">
                <div className="custom-radio">
                  <input type="radio" name="salary_4" className="custom-control-input" id="radio218" value="No" onChange={(e) => setQuestionValue(4, e)} checked={formik.values.fifth_value == 'No'} />
                  <label className="custom-control-label" htmlFor="radio218">No</label>
                </div>
              </div>
            </div>
            {firendInfo ?

              <div className="row login-page mtb-0">
                <div className="form-row col-md-6 col-lg-6">
                  <i className="fa fa-user"></i>
                  <input type="text" onChange={(e) => setFriendValue(e, 'name')} value={formik.values.name} />

                  <span>Name</span>
                  {formik.touched.name && formik.errors.name ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.name}</div> : ''}
                </div>
                <div className="form-row col-md-6 col-lg-6">
                  <i className="fa fa-envelope"></i>
                  <input type="text" onChange={(e) => setFriendValue(e, 'email')} value={formik.values.email} />

                  <span>Email</span>
                  {formik.touched.email && formik.errors.email ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.email}</div> : ''}
                </div>
                <div className="form-row col-md-6 col-lg-6">
                  <i className="fa fa-phone"></i>
                  <input type="text" onChange={(e) => setFriendValue(e, 'phone')} value={formik.values.phone} />

                  <span>Phone</span>
                  {formik.touched.phone && formik.errors.phone ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.phone}</div> : ''}
                </div>
              </div>



              : ''}

            {formik.touched.fifth_value && formik.errors.fifth_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.fifth_value}</div> : ''}
          </div>
          <div className="row login-page mtb-0">
            <div className="form-row col-md-12 col-lg-12 mb-0">
              <p className="mtb-0">What size t-shirt do you wear?</p>
            </div>
          </div>
          <div className="row login-page mtb-0">
            <div className="form-row col-md-6 col-lg-6">
              <i className="fas fa-truck-pickup"></i>
              <select onChange={(e) => setQuestionValue(5, e)} value={formik.values.six_value}>
                <option value="">Select</option>
                <option value="Medium">Medium</option>
                <option value="Large">Large</option>
                <option value="X-Large">X-Large</option>
                <option value="XX-Large">XX-Large</option>
                <option value="XXX-Large">XXX-Large</option>
              </select>
              {formik.touched.six_value && formik.errors.six_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.six_value}</div> : ''}
            </div>

          </div>

          <div className="row login-page mtb-0">
            <div className="form-row col-md-12 col-lg-12 mb-0">
              <p className="mtb-0">How did you hear about Move It?</p>
            </div>
          </div>
          <div className="row login-page mtb-0">
            <div className="form-row col-md-12 col-lg-12">
              <input className="pl-15" type="text" onChange={(e) => setQuestionValue(6, e)} value={formik.values.seven_value} />
              {formik.touched.seven_value && formik.errors.seven_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.seven_value}</div> : ''}
            </div>

          </div>


        </div>

        <div className="row">
          <div className="col-md-12">
            <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
              <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
            <button className="btn step-btn" type="submit" ><span>Continue</span></button>
          </div>
        </div>
      </form>
    </div>

  )
}

const StepFour = (props) => {

  const formik = useFormik({
    initialValues: {
      first_value: props.data.question_optional_data[0].answer,
      second_value: props.data.question_optional_data[1].answer,
      third_value: props.data.question_optional_data[2].answer,
      fourth_value: props.data.question_optional_data[3].answer
    },
    validationSchema: yup.object({
      first_value: yup.number().typeError('You must specify a number.').required('Please select days move number.'),
      second_value: yup.string().required('Please select answer of question 2.'),
      third_value: yup.string().required('Please enter something here. ')
    }),
    onSubmit: values => {
      props.next(props.data)
    }
  });

  const setQuestionValue = (index, event = '') => {
    if (index == 0 && event) {
      formik.setFieldValue('first_value', event.target.value);
      props.data.question_optional_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 1 && event) {
      formik.setFieldValue('second_value', event.target.value);
      // let newArr = [...props.data.question_data]; // copying the old datas array
      props.data.question_optional_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 2 && event) {
      formik.setFieldValue('third_value', event.target.value);
      props.data.question_optional_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }

    else if (index == 3 && event) {
      formik.setFieldValue('fourth_value', event.target.value);
      props.data.question_optional_data[index].answer = event.target.value; // replace e.target.value with whatever you want to change it to
      props.setData(props.data);
    }


  }

  return (
    <>
      <div className="form-steps" style={{ display: "block" }}>
        <h3 className="border-bottom">More Information</h3>

        <form action="#" className="job-application-form" onSubmit={formik.handleSubmit} autoComplete="off">

          <div className="row login-page mtb-0">


            <div className="col-md-12 col-lg-12 mb-2">
              <p className="mtb-0">Each Move It job typically takes anywhere from 30 minutes to a couple hours. How many Move It jobs are you hoping to do each week?</p>
            </div>
            <div className="form-row col-md-6 col-lg-6">
              <i className="fas fa-clock"></i>
              <input type="text" onChange={(e) => setQuestionValue(0, e)} value={formik.values.first_value} />
              <span>Type your estimate</span>
              {formik.touched.first_value && formik.errors.first_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.first_value}</div> : ''}
            </div>

            <div className="form-row col-md-12 col-lg-12 linebtween">
              <p className="mb-0">Have you served in the US Armed Forces?</p>
              <div className="col-md-12">
                <div className="form-group radio-group">
                  <div className="custom-radio">
                    <input type="radio" name="salary_11" className="custom-control-input" id="radio219" value="Yes" onChange={(e) => setQuestionValue(1, e)} checked={formik.values.second_value == 'Yes'} />
                    <label className="custom-control-label" htmlFor="radio219">Yes</label>
                  </div>
                </div>
                <div className="form-group radio-group">
                  <div className="custom-radio">
                    <input type="radio" name="salary_11" className="custom-control-input" id="radio220" value="No" onChange={(e) => setQuestionValue(1, e)} checked={formik.values.second_value == 'No'} />
                    <label className="custom-control-label" htmlFor="radio220">No</label>
                  </div>
                </div>
              </div>
              {formik.touched.second_value && formik.errors.second_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.second_value}</div> : ''}
            </div>

            <div className="col-md-12 col-lg-12 mb-2">
              <p className="mtb-0">In a few short sentence, tell us why you will be a great Move It Pro.</p>
            </div>
            <div className="form-row col-md-12 col-lg-12">
              <div className="form-group check-group w-100p">
                <textarea className="form-control" onChange={(e) => setQuestionValue(2, e)} value={formik.values.third_value}></textarea>
                {formik.values.third_value == '' ?
                  <label htmlFor="inputText">Type answer here</label>
                  : ''}
              </div>
              {formik.touched.third_value && formik.errors.third_value ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.third_value}</div> : ''}
            </div>
            <div className="col-md-12 col-lg-12 mb-2">
              <p className="mtb-0">We want our customers to have a comfortable experience. What can we put on your profile about you? (Optional)</p>
            </div>
            <div className="form-row col-md-12 col-lg-12">
              <div className="form-group check-group w-100p">
                <textarea className="form-control" onChange={(e) => setQuestionValue(3, e)} value={formik.values.fourth_value}></textarea>
                {formik.values.fourth_value == '' ?
                  <label htmlFor="inputText">Favorite type of music, sports, food, season etc.</label>
                  : ''}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
                <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
              <button className="btn step-btn" type="submit" ><span>Continue</span></button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

const StepFive = (props) => {

  const formik = useFormik({
    initialValues: props.data,
    validationSchema: yup.object({
      photo_url: yup.string().required('Please select image.')
    }),
    onSubmit: values => {
      props.next(values)
    }
  });
  const uploadImage = (e) => {
    const filesSelected = Array.from(e.target.files);
    const validSelectedFiles = filesSelected.filter((file) =>
    ['image/png', 'image/gif', 'image/jpeg'].includes(file.type)
    );

    if (validSelectedFiles.length !== filesSelected.length) {
        toast.error('Some files are not valid. Only PNG, GIF, and JPEG are allowed.');
    } else {
      if (e.target.files.length) {
        props.setloading(true);
        var formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
          formData.append('image[]', e.target.files[i])
        }
        formData.append("folder_name", 'helper_profile');
        api.postApi('upload-images', formData, true).then(response => {
          formik.setFieldValue(`photo_url`, response.data[0]);
          props.setloading(false);
        }).catch(error => {
          props.props.setloading(false);
          toast.error(error.message);
        });
      }
    }
  }
  return (
    <div className="form-steps" style={{ display: "block" }}>
      <h3 className="mb-0 text-center">You are all set</h3>
      <form action="#" className="job-application-form" onSubmit={formik.handleSubmit} autoComplete="off">
        <p className="mtb-0 text-center">Upload Your Headshot Photo</p>
        <div className="row headshot d-flex justify-content-center">
          <div className="avatar-upload">
            <div className="avatar-edit">
              <input type="file" id="imageUpload_profile" accept=".png, .jpg, .jpeg" onChange={(e) => uploadImage(e)} />
              <label htmlFor="imageUpload_profile"></label>
            </div>
            <div className="avatar-preview">
              <div id="imagePreview" style={{ backgroundImage: formik.values.photo_url ? "url(" + formik.values.photo_url + ")" : "url(web/img/headshot.jpg)" }}></div>
            </div>
          </div>
          {formik.touched.photo_url && formik.errors.photo_url ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.photo_url}</div> : ''}
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
              <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
            <button className="btn step-btn" type="submit" ><span>I'm Done</span></button>
          </div>
        </div>
      </form>
    </div>

  )
}

const StepSix = (props) => {


  const formik = useFormik({
    initialValues: {
      first_value: props.data.helper_agreement ? true : false,
      second_value: props.data.helper_agreement ? true : false,
      third_value: props.data.helper_agreement ? true : false,
      fourth_value: props.data.helper_agreement ? true : false,
      fifth_value: props.data.helper_agreement ? true : false,
      six_value: props.data.helper_agreement ? true : false
    },
    validationSchema: yup.object({
      first_value: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      second_value: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      third_value: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      fourth_value: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      fifth_value: yup.boolean().oneOf([true], 'Please select terms and conditions !'),
      six_value: yup.boolean().oneOf([true], 'Please select terms and conditions !')
    }),
    onSubmit: values => {
      props.data.helper_agreement = true;
      props.setData(props.data);
      props.next(props.data)
    }
  });


  return (
    <div className="form-steps" style={{ display: "block" }}>
      <h3 className="mb-0">Technology Service Agreement</h3>
      <form action="#" className="job-application-form" onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="row itemstep login-page mb-3">
          <div className="col-12 col-md-12 col-lg-12 mb-2" style={{
            height: "300px",
            overflowY: "scroll"
          }}>
            <div className="form-group check-group">
              <p className="pstep-from"> This Technology Services Agreement (“Agreement”) is entered into by and between Move It, LLC., a Nevada Limited Liability Company (“Company”), and You personally and as a Sole Proprietor, Company or Corporation (“You”). </p>
              <p className="pstep-from"> Company is a technology platform that connects independent contractors who offer Services (as defined below) using the Company Services (as defined below) to Users of the App (as defined below) who are looking for independent contractors for Services. The Company Services enable an authorized Services provider to use the App to seek, receive and fulfill requests for Services from an authorized User of the Company’s mobile applications. You, desire to enter into this Agreement for the purpose of accessing and using the Company Services. </p>
              <p className="pstep-from">
                <b>You acknowledge and agree that Company is a technology services provider that does not provide transportation, moving or services</b>
              </p>
              <p className="pstep-from"> In order to use the Company Services, You must agree to the terms and conditions that are set forth below. Upon Your execution (electronic or otherwise) of this Agreement, You and Company shall be bound by the terms and conditions set forth herein. </p>
              <h6 className="caseuper"> BY VIRTUE OF YOUR ELECTRONIC EXECUTION OF THIS AGREEMENT, YOU WILL BE ACKNOWLEDGING THAT YOU HAVE READ AND UNDERSTOOD ALL OF THE TERMS OF THIS AGREEMENT (INCLUDING THE ARBITRATION PROVISION) AND HAVE TAKEN TIME TO CONSIDER THE CONSEQUENCES OF THIS IMPORTANT BUSINESS DECISION. </h6>
              <h3>1. Definitions</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Affiliate” means an entity that, directly or indirectly, controls, is under the control of, or is under common control with a party, where control means having more than fifty percent (50%) of the voting stock or other ownership interest or the majority of the voting rights of such entity. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “App” means the mobile application provided by Company that enables Moving providers to access the Company Services for the purpose of seeking, receiving and fulfilling on- demand requests for Services by Users, as may be updated or modified from time to time. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “City Addendum” means an addendum or supplemental information to this Agreement setting forth additional Territory-specific terms, as made available and as updated by Company from time to time. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.4</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Company Data” means all data related to the access and use of the Company Services hereunder, including all data related to Users (including User Information), all data related to the provision of Services via the Company Services and the App, and the Provider ID. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.5</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Company Device” means a mobile device owned or controlled by Company that is provided to You solely for Your use of the App to provide Services.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.6</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Device” means a Company Device or Your Device, as the case may be.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.7</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Driver ID” means the identification and password key assigned by Company to You that enables You to use and access the App.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.8</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Services Fee” has the meaning set forth in Section 4.1.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.9</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Services” Means retrieval and delivery of items owned by User and the User and/or a third-party or items owned by a third-party and requested to be moved by User, to another location as requested by the User. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.10</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Service Fee” has the meaning set forth in Section 4.4.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.11</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">“Territory” means the city or metro areas in the United States in which You are enabled by the App to receive requests for Services.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.12</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Tolls” means any applicable road, bridge, ferry, tunnel and airport charges and fees, including inner-city congestion, environmental or similar charges as reasonably determined by the Company Services based on available information. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.13</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Company Services” mean Company’s on-demand lead generation and related services licensed by Company to Company that enable Services providers to seek, receive and fulfill on-demand requests for Services by Users seeking Services; such Company Services include access to the App and Company’s software, websites, payment services as described in Section 4 below, and related support services systems, as may be updated or modified from time to time. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.14</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “User” means an end user authorized by Company to use the Company mobile application for the purpose of obtaining Services offered by Company’s Services provider customers. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.15</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “User Information” means information about a User made available to You in connection with such User’s request for and use of Services, which may include the User’s name, pick-up location, contact information and photo. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.16</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Vehicle” means Your vehicle that: (a) meets the then-current Company requirements for a vehicle on the Company Services; and (b) Company authorizes for Your use for the purpose of providing Services. You are required to obtain separate authorization for the use of your Vehicle for Services. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">1.17</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> “Your Device” means a mobile device owned or controlled by You: (a) that meets the then- current Company specifications for mobile devices and (b) on which the App has been installed as authorized by Company solely for the purpose of providing Services. </p>
                </div>
              </div>
              <h3>2. Use of the Company Services</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Driver IDs.</b> Company will issue You a Driver ID to enable You to access and use the App on a Device in accordance with this Agreement. Company reserves the right to deactivate Your Driver ID if You have not fulfilled a request for Services using the App at least once a month. <b> You agree that You will maintain Your Driver ID in confidence and not share Your Driver ID with any third party. You will immediately notify Company of any actual or suspected breach or improper use or disclosure of Your Driver ID or the App. </b>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Provision of Services.</b> When the App is active, User requests for Services may appear to You via the App, if You are available and in the vicinity of the User. If You accept a User’s request for Services, the Company Services will provide You with certain User Information via the App, including the User’s first name and pickup and delivery location. When utilizing Services within the App, in order to enhance User satisfaction with the Company mobile application and Your Services, it is recommended that You wait at least ten (10) minutes for a User to show up at the requested moving location. You will obtain the destination from the User, either in person upon pickup of the items to be moved or from the App, if the User elects to enter such destination via Company’s mobile application. You are prohibited from transporting the User when moving their personal belongings. You acknowledge and agree that once You have accepted a User’s request for Services, Company’s mobile application may provide certain information about You to the User, including Your first name, contact information, photo and location, and Your Vehicle’s make and license plate number. You shall not contact any Users or use any User’s personal data for any reason other than for the purposes of fulfilling Services. As between Company and You, You acknowledge and agree that: (a) You shall be solely responsible for determining the most effective, efficient and safe manner to perform each instance of Services; and (b) You shall provide all necessary equipment, tools and other materials, at Your own expense, necessary to perform the Services.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Your Relationship with Users.</b> You acknowledge and agree that Your provision of Services to Users creates a direct business relationship between You and the User. Company is solely acting as a technology platform to connect you with Users and is not responsible or liable for the actions or inactions of a User in relation to You, Your activities, the User’s activity, the User’s personal property or Your Vehicle. You shall have the sole responsibility for any obligations or liabilities to Users or third parties that arise from Your provision of Services. You acknowledge and agree that You are solely responsible for taking such precautions as may be reasonable and proper (including maintaining adequate insurance that meets the requirements of all applicable laws including motor vehicle financial responsibility laws) regarding any acts or omissions of a User or third party. You acknowledge and agree that Company may release Your contact and/or insurance information to a User upon such User’s reasonable request. You acknowledge and agree that, unless specifically consented to by a User, You may not transport, or allow inside Your Vehicle, individuals during the performance of Services for such User. You acknowledge and agree that all deliveries of the User’s personal property, should be transported directly to their specified destination, as directed by the applicable User, without unauthorized interruption or unauthorized stops. You understand that when making deliveries or transporting User’s personal property that a User may request you make multiple stops, through the App, prior to reaching the final destination, these requests are authorized by use of the App, and by utilizing the Company Services You are agreeing that these requests are reasonable and proper and that You will have allotted sufficient time in Your schedule to account for multiple stops.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.4</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Your Relationship with Company. You acknowledge and agree that Company’s provision to You of the App and the Company Services creates a direct business relationship between Company and You. Company does not, and shall not be deemed to, direct or control You generally or in Your performance under this Agreement specifically, including in connection with Your provision of the Services, Your acts or omissions, or Your operation and maintenance of Your Vehicle. You retain the sole right to determine when, where, and for how long You will utilize the App or the Company Services. You retain the option, via the App, to attempt to accept or to decline or ignore a User’s request for Services via the Company Services, or to cancel an accepted request for Services via the App, subject to Company’s then-current cancellation policies. With the exception of any signage required by local law or permit/license requirements, Company shall have no right to require You to: (a) display Company’s or any of its Affiliates’ names, logos or colors on Your Vehicle(s); or (b) wear a uniform or any other clothing displaying Company’s or any of its Affiliates’ names, logos or colors. You acknowledge and agree that You have complete discretion to provide services or otherwise engage in other business or employment activities. For the sake of clarity, You understand that You retain the complete right to; (i) use other software application services in addition to the Company Services; and (ii) engage in any other occupation or business. Company retains the right to deactivate or otherwise restrict You from accessing or using the App or the Company Services in the event of a violation or alleged violation of this Agreement, Your disparagement of Company or any of its Affiliates, Your act or omission that causes harm to Company’s or its Affiliates’ brand, reputation or business as determined by Company in its sole discretion. You understand, agree and acknowledge that this Agreement does not constitute an offer of employment by Company and Your use of the App and Company Services shall not create an employer/employee relationship. At no time shall you be considered an employee of the Company, nor shall you receive any benefits normally afforded to an employee. Accordingly, You shall not receive vacation pay, sick pay, retirement benefits, or any other employee benefit with respect to Your services. Company will neither withhold Federal income tax against Your fees, nor pay FICA, State unemployment or other employment taxes with respect thereto. </p>
                </div>
              </div>
              <h6>2.5 Ratings.</h6>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.5.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You acknowledge and agree that: (a) after receiving Services, a User will be prompted by Company’s mobile application to provide a rating of You and such Services and, optionally, to provide comments or feedback about You and such Services; and (b) after providing Services, You will be prompted by the App to provide a rating of the User and, optionally, to provide comments or feedback about the User. You shall provide Your ratings and feedback in good faith. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.5.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You acknowledge that Company desires that Users have access to high-quality services via Company’s mobile application. In order to continue to receive access to the App and the Company Services, You must maintain an average rating by Users that exceeds the minimum average acceptable rating established by Company for Your Territory, as may be updated from time to time by Company in its sole discretion (“Minimum Average Rating”). Your average rating is intended to reflect Users’ satisfaction with Your Services rather than Your compliance with any of Company’s policies or recommendations. In the event Your average rating falls below the Minimum Average Rating, Company will notify You and may provide You, in Company’s discretion, a limited period of time to raise Your average rating above the Minimum Average Rating. If You do not increase Your average rating above the Minimum Average Rating within the time period allowed (if any), Company reserves the right to deactivate Your access to the App and the Company Services. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.5.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Company and its Affiliates reserve the right to use, share and display Your and User ratings and comments in any manner in connection with the business of Company and its Affiliates without attribution to You or Your approval. You acknowledge and agree that Company and its Affiliates are distributors (without any obligation to verify) and not publishers of Your and User ratings and comments, provided that Company and its Affiliates reserve the right to edit or remove comments in the event that such comments include obscenities or other objectionable content, include an individual’s name or other personal information, or violate any privacy laws, other applicable laws or Company’s or its Affiliates’ content policies. </p>
                </div>
              </div>
              <h6>2.6 Devices.</h6>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.6.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You shall be required to use Your Device and to provide all equipment and training required to provide the Services. Company will not provide any Company Devices or equipment to You for use. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.6.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> If You elect to use the Company Services: (i) You are responsible for the acquisition, cost and maintenance of Your Devices as well as any necessary wireless data plan; (ii) You are responsible for the acquisition, cost and maintenance of any equipment required to provide Services; and (iii) Company shall make available the App for installation on Your Device. Company hereby grants You a personal, non-exclusive, non-transferable license to install and use the App on Your Device solely for the purpose of providing Services. You agree to not provide, distribute or share, or enable the provision, distribution or sharing of, the App (or any data associated therewith) with any third party. The foregoing license grant shall immediately terminate and You will delete and fully remove the App from Your Device in the event that You cease to provide Services using Your Device. You agree that: (i) use of the App on Your Device requires an active data plan with a wireless carrier associated with Your Device, which data plan will be provided by You at Your own expense; and (ii) use of the App on Your Device as an interface with the Company Services may consume very large amounts of data through the data plan. <b> COMPANY ADVISES THAT YOUR DEVICE ONLY BE USED UNDER A DATA PLAN WITH UNLIMITED OR VERY HIGH DATA USAGE LIMITS, AND COMPANY SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY FEES, COSTS, OR OVERAGE CHARGES ASSOCIATED WITH ANY DATA PLAN. </b>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">2.7</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Location Based Services.</b> You acknowledge and agree that Your geo-location information must be provided to the Company Services via a Device in order to provide Services. You acknowledge and agree that: (a) Your geo-location information may be obtained by the Company Services while the App is running; and (b) the approximate location of Your Vehicle will be displayed to the User before and during the provision of Services to such User. In addition, Company and its Affiliates may monitor, track and share with third parties Your geo-location information obtained by the App and Device for safety and security purposes.
                  </p>
                </div>
              </div>
              <h3>3. You and Your Vehicle</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">3.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Your Requirements. </b>You acknowledge and agree that at all times, You shall: (a) hold and maintain (i) a valid driver's license with the appropriate level of certification to operate Your Vehicle, and (ii) all licenses, permits, approvals and authority applicable to You that are necessary to provide Services to third parties in the Territory; (b) possess the appropriate and current level of training, expertise and experience to provide Services in a professional manner with due skill, care and diligence; and (c) maintain high standards of professionalism, service and courtesy. You acknowledge and agree that Company has no duty to perform background, licensing or driving record checks; however, may choose to in its sole discretion and You may be subject to certain background and driving record checks from time to time in order to qualify to provide, and remain eligible to provide, Services. You acknowledge and agree that Company reserves the right, at any time in Company’s sole discretion, to deactivate or otherwise restrict You from accessing or using the App or the Company Services if You fail to meet the requirements set forth in this Agreement.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">3.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Vehicle Requirements.</b> You acknowledge and agree that Your Vehicle shall at all times be: (a) properly registered and licensed to operate to provide the services contemplated in this Agreement in the state wherein you will be providing Services; (b) is owned or leased by You, or otherwise in Your lawful possession; (c) suitable for performing the Services contemplated by this Agreement; and (d) maintained in good operating condition, consistent with industry safety and maintenance standards for a Vehicle of its kind and any additional standards or requirements in the applicable Territory, and in a clean and sanitary condition.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">3.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Documentation.</b> To ensure Your compliance with all requirements in Sections 3.1 and 3.2 above, You must provide Company with written copies of all such licenses, permits, approvals, authority, registrations and certifications prior to Your provision of any Services. Thereafter, You must submit to Company written evidence of all such licenses, permits, approvals, authority, registrations and certifications as they are renewed. Company shall, upon request, be entitled to review such licenses, permits, approvals, authority, registrations and certifications from time to time, and Your failure to provide or maintain any of the foregoing shall constitute a material breach of this Agreement. Company reserves the right to independently verify Your documentation from time to time in any way Company deems appropriate in its reasonable discretion.
                  </p>
                </div>
              </div>
              <h3>4. Financial Terms</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Fee Calculation and Your Payment.</b> You are entitled to charge a fee for each instance of completed Services provided to a User that are obtained via the Company Services (“Services Fee”), where such Services Fee is calculated per hour of Services provided from the time you arrive at the User’s initial destination until the time you reach the User’s final destination plus mileage which shall be calculated from the point of the User’s initial destination until the time you reach the User’s final destination (as determined by Company using location-based services enabled through the Device) and/or time amounts for the applicable Territory (“Services Fee Calculation”). You acknowledge that while Users may provide You with gratuity, that gratuity is not required to be paid to you and You shall not base your rating of the User on whether any gratuity was received by You. You are also entitled to charge User for any Tolls, taxes or fees incurred during the provision of Services, if applicable. You: (i) appoint Company as Your limited payment collection agent solely for the purpose of accepting the Services Fee, applicable Tolls and, depending on the region and/or if requested by You, applicable taxes and fees from the User on Your behalf via the payment processing functionality facilitated by the Company Services; and (ii) agree that payment made by User to Company (or to an Affiliate of Company acting as an agent of Company) shall be considered the same as payment made directly by User to You. In addition, the parties acknowledge and agree that as between You and Company, the Services Fee is a recommended amount, and the primary purpose of the pre-arranged Services Fee is to act as the default amount in the event You do not negotiate a different amount. You shall always have the right to: (i) charge a Services Fee that is less than the pre-arranged Services Fee; or (ii) negotiate, at Your request, a Services Fee that is higher than the pre- arranged Services Fee (each of (i) and (ii) herein, a “Negotiated Services Fee”). Company shall consider all such requests from You in good faith. Company agrees to remit, or cause to be remitted, to You on at least a weekly basis: (a) the Services Fee less the applicable Service Fee; (b) the Tolls; and (c) depending on the region, certain taxes and ancillary fees.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Changes to Services Fee Calculation.</b> Company reserves the right to change the Services Fee Calculation at any time in Company’s discretion based upon local market factors, and Company will provide You with notice in the event of changes to the base Services Fee, per mile, and/or per minute amounts that would result in a change in the recommended Services Fee. Continued use of the Company Services after any such change in the Services Fee Calculation shall constitute Your consent to such change.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Services Fee Adjustment.</b> Company reserves the right to: (i) adjust the Services Fee for a particular instance of Users may choose to provide you with gratuity (e.g., You took an inefficient route, You failed to properly end a particular instance of Services in the App, technical error in the Company Services, etc.); or (ii) cancel the Services Fee for a particular instance of Users may choose to provide you with gratuity (e.g., User is charged for Services that were not provided, in the event of a User complaint, fraud, etc.). Company’s decision to reduce or cancel the Services Fee in any such manner shall be exercised in a reasonable manner.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.4</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Service Fee.</b> In consideration of Company’s provision of the App and the Company Services for Your use and benefit hereunder, You agree to pay Company a service fee on a per Services transaction basis calculated as a percentage of the Services Fee determined by the Services Fee Calculation (regardless of any Negotiated Services Fee), as provided to You via email or otherwise made available electronically by Company from time to time for the applicable Territory (“Service Fee”). In the event regulations applicable to Your Territory require taxes to be calculated on the Services Fee, Company shall calculate the Service Fee based on the Services Fee net of such taxes. Company reserves the right to change the Service Fee at any time in Company’s discretion based upon local market factors, and Company will provide You with notice in the event of such change. Continued use of the Company Services after any such change in the Service Fee calculation shall constitute Your consent to such change.
                  </p>
                </div>
              </div>
              <h6>4.5 Cancellation Charges.</h6>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment"></span>
                </div>
                <div className="col-md-11 col-10">
                  <p>
                    <b>a. Cancellation by User. </b> You acknowledge and agree that Users may elect to cancel requests for Services that have been accepted by You via the App at any time prior to Your arrival. In the event that a User cancels an accepted request for Services, Company may charge the User a cancellation fee on Your behalf. If charged, this cancellation fee shall be deemed the Services Fee for the cancelled Services for the purpose of remittance to You hereunder (“Cancellation Fee”). The parties acknowledge and agree that as between You and Company, this Cancellation Fee is a recommended amount, and the primary purpose of such Cancellation Fee is to act as the default amount in the event You do not negotiate a different amount. You shall always have the right to: (i) charge a cancellation fee that is less than the Cancellation Fee; or (ii) negotiate, at Your request, a cancellation fee that is lower than the Cancellation Fee (each of (i) and (ii) herein, a “Negotiated Cancellation Fee”). If charged, the Cancellation Fee (regardless of any Negotiated Cancellation Fee) shall be deemed the Services Fee for the cancelled Services for the purpose of remittance to You hereunder.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment"></span>
                </div>
                <div className="col-md-11 col-10">
                  <p>
                    <b>b. Cancellation by You. </b> If You accept a request for Services from a User and You cancel at any time prior to arriving at the User’s initial destination You will be billed a minimum of a $10 cancellation fee. If you accept a request for Services at least 24 hours’ prior to the time requested by the User and cancel less than 2 hours prior to your schedule arrival time then You will be charged a cancellation fee totaling one hour of time normally billed to Users for Your Services Fee. If You cancel 3 projects within a 30 day period, Your account will be suspended for 1 week in addition to the cancellation fees.
                  </p>
                  <p> If you fail to arrive for Services that you have accepted and have failed to cancel, for your first offense, You will be billed a cancellation fee totaling two hours of time normally billed to Users for Your Services Fee and immediately suspended for 7 days. You will be considered a No Show if You or Your representative or employees have not arrived at the scheduled pickup location within 20 minutes of the start time. If at any time You fail to show up for Services after Your first offense, You will again be billed a cancellation fee totaling two hours of time normally billed to Users for Your Services Fee and will be permanently deactivated from the platform. </p>
                  <p>Cancellation Fees may be charged to your card or bank account on file or deducted from future earnings.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.6</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Risk of Loss/Damage to Your Vehicle/Damage to User’s Personal Property. By Your use of the App, You understand, agree and acknowledge, that at no time, for any reason and under any circumstance, will the Company be responsible for payment for any damage to Your vehicle, a third-party’s vehicle or damage or loss of any User’s personal property being transported by You. </b> Should Your Vehicle become damaged as a result of a User, You may submit a claim through the App for payment for the damages from the User. Company will review your claim and any supporting documentation and if the Company determines the damage was caused due to the User’s negligence then Company shall notify the User and attempt to charge the User’s selected payment method for a reasonable amount (evidenced by receipts or estimates provided by You, or if no receipts or estimates are provided, to be determined by the Company using reasonable discretion) to repair the damage. If You should determine that Your claim was rejected in error or that You should receive any additional compensation, or the payment is declined or rejected by the User’s financial institution, then You understand, agree and acknowledge that any claims You have are between You and the User and you indemnify the Company for and against any claims, causes of action, cross claim and/or third-party claims that You or the User may bring as a result of damages.
                  </p>
                  <p>
                    <b>a.</b> You may enter into subsequent agreements with the User for risk of loss. If You do not enter into any subsequent agreements with the User for risk of loss then You shall be responsible for the User’s personal property from the time you begin moving the personal property into Your Vehicle until the time you deliver the User’s personal property and You shall be responsible for loss or damage of any items during this period. At no time shall the Company be responsible for the loss or damage of any of the User’s personal property or for any damage caused to other property while moving or delivering the User’s personal property. Any subsequent agreements created by You or the User or entered into by You or the User shall not transfer any liability for risk of loss or damage to the Company for User’s personal property or other property. Company shall not honor or request payment from the User for any funds You believe You are owed outside of the fees and costs allocated for in the App.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.7</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Receipts. </b>As part of the Company Services, Company provides You a system for the delivery of receipts to Users for Services rendered. Upon Your completion of Services for a User, Company prepares an applicable receipt and issues such receipt to the User via email on Your behalf. Such receipts are also provided to You via email or the online portal available to You through the Company Services. Receipts include the breakdown of amounts charged to the User for Services and may include specific information about You, including Your name, contact information and photo, as well as a map of the route You took. Any corrections to a User’s receipt for Services must be submitted to Company in writing within three (3) business days after the completion of such Services. Absent such a notice, Company shall not be liable for any mistakes in or corrections to the receipt or for recalculation or disbursement of the Services Fee.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.8</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> No Additional Amounts. </b>You acknowledge and agree that, for the mutual benefit of the parties, through advertising and marketing, Company and its Affiliates may seek to attract new Users to Company and to increase existing Users’ use of Company’s mobile application. You acknowledge and agree such advertising or marketing does not entitle You to any additional monetary amounts beyond the amounts expressly set forth in this Agreement.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">4.9</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Taxes.</b> You acknowledge and agree that You are required to: (a) complete all tax registration obligations and calculate and remit all tax liabilities related to Your provision of Services as required by applicable law; and (b) provide Company with all relevant tax information. You further acknowledge and agree that You are responsible for taxes on Your own income arising from the performance of Services. Notwithstanding anything to the contrary in this Agreement, Company may in its reasonable discretion based on applicable tax and regulatory considerations, collect and remit taxes resulting from Your provision of Services and/or provide any of the relevant tax information You have provided pursuant to the foregoing requirements in this Section 4.9 directly to the applicable governmental tax authorities on Your behalf or otherwise.
                  </p>
                </div>
              </div>
              <h3>5. Proprietary Rights; License</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">5.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>License Grant.</b> Subject to the terms and conditions of this Agreement, Company hereby grants You a non-exclusive, non-transferable, non-sublicensable, non-assignable license, during the term of this Agreement, to use the Company Services (including the App on a Device) solely for the purpose of providing Services to Users and tracking resulting Services Fees and Fees. All rights not expressly granted to You are reserved by Company, its Affiliates and their respective licensors.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">5.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Restrictions.</b> You shall not, and shall not allow any other party to: (a) license, sublicense, sell, resell, transfer, assign, distribute or otherwise provide or make available to any other party the Company Services, App or any Company Device in any way; (b) modify or make derivative works based upon the Company Services or App; (c) improperly use the Company Services or App, including creating Internet “links” to any part of the Company Services or App, “framing” or “mirroring” any part of the Company Services or App on any other websites or systems, or “scraping” or otherwise improperly obtaining data from the Company Services or App; (d) reverse engineer, decompile, modify, or disassemble the Company Services or App, except as allowed under applicable law; or (e) send spam or otherwise duplicative or unsolicited messages. In addition, You shall not, and shall not allow any other party to, access or use the Company Services or App to: (i) design or develop a competitive or substantially similar product or service; (ii) copy or extract any features, functionality, or content thereof; (iii) launch or cause to be launched on or in connection with the Company Services an automated program or script, including web spiders, crawlers, robots, indexers, bots, viruses or worms, or any program which may make multiple server requests per second, or unduly burden or hinder the operation and/or performance of the Company Services; or (iv) attempt to gain unauthorized access to the Company Services or its related systems or networks.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">5.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Ownership.</b> The Company Services, App and Company Data, including all intellectual property rights therein, and the Company Devices are and shall remain (as between You and Company) the property of Company, its Affiliates or their respective licensors. Neither this Agreement nor Your use of the Company Services, App or Company Data conveys or grants to You any rights in or related to the Company Services, App or Company Data, except for the limited license granted above. Other than as specifically permitted by the Company in connection with the Company Services, You are not permitted to use or reference in any manner Company’s, its Affiliates’, or their respective licensors’ company names, logos, products and service names, trademarks, service marks, trade dress, copyrights or other indicia of ownership, alone and in combination with other letters, punctuation, words, symbols and/or designs (the "COMPANY Marks and Names") for any commercial purposes. You agree that You will not try to register or otherwise use and/or claim ownership in any of the COMPANY Marks and Names, alone or in combination with other letters, punctuation, words, symbols and/or designs, or in any confusingly similar mark, name or title, for any goods and services.
                  </p>
                </div>
              </div>
              <h3>6. Confidentiality</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">6.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Each party acknowledges and agrees that in the performance of this Agreement it may have access to or may be exposed to, directly or indirectly, confidential information of the other party ("Confidential Information"). Confidential Information includes Company Data, Driver IDs, User Information, and the transaction volume, marketing and business plans, business, financial, technical, operational and such other non-public information of each party (whether disclosed in writing or verbally) that such party designates as being proprietary or confidential or of which the other party should reasonably know that it should be treated as confidential. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">6.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Each party acknowledges and agrees that: (a) all Confidential Information shall remain the exclusive property of the disclosing party; (b) it shall not use Confidential Information of the other party for any purpose except in furtherance of this Agreement; (c) it shall not disclose Confidential Information of the other party to any third party, except to its employees, officers, contractors, agents and service providers ("Permitted Persons") as necessary to perform under this Agreement, provided Permitted Persons are bound in writing to obligations of confidentiality and non-use of Confidential Information no less protective than the terms hereof; and (d) it shall return or destroy all Confidential Information of the disclosing party, upon the termination of this Agreement or at the request of the other party (subject to applicable law and, with respect to Company, its internal record-keeping requirements). </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">6.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Notwithstanding the foregoing, Confidential Information shall not include any information to the extent it: (a) is or becomes part of the public domain through no act or omission on the part of the receiving party; (b) was possessed by the receiving party prior to the date of this Agreement without an obligation of confidentiality; (c) is disclosed to the receiving party by a third party having no obligation of confidentiality with respect thereto; or (d) is required to be disclosed pursuant to law, court order, subpoena or governmental authority, provided the receiving party notifies the disclosing party thereof and provides the disclosing party a reasonable opportunity to contest or limit such required disclosure. </p>
                </div>
              </div>
              <h3>7. Privacy</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">7.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Disclosure of Your Information. </b>Subject to applicable law, Company and its Affiliates may, but shall not be required to, provide to You, a User, an insurance company and/or relevant authorities and/or regulatory agencies any information (including personal information (e.g., information obtained about You through any background check) and any Company Data) about You or any Services provided hereunder if: (a) there is a complaint, dispute or conflict, including an accident, or damage or destruction of a User’s personal property between You and a User; (b) it is necessary to enforce the terms of this Agreement; (c) it is required, in Company’s or any Affiliate’s sole discretion, by applicable law or regulatory requirements (e.g., Company or its Affiliates receive a subpoena, warrant, or other legal process for information); (d) it is necessary, in Company’s or any Affiliate’s sole discretion, to (1) protect the safety, rights, property or security of Company or its Affiliates, the Company Services or any third party; (2) to protect the safety of the public for any reason including the facilitation of insurance claims related to the Company Services; (3) to detect, prevent or otherwise address fraud, security or technical issues; (4) to prevent or stop activity which Company or any of its Affiliates, in their sole discretion, may consider to be, or to pose a risk of being, an illegal, unethical, or legally actionable activity); or (e) it is required or necessary, in Company’s or any Affiliate’s sole discretion, for insurance or other purposes related to Your ability to qualify, or remain qualified, to use the Company Services. You understand that Company may retain Your personal data for legal, regulatory, safety and other necessary purposes after this Agreement is terminated.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">7.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Company and its Affiliates may collect Your personal data during the course of Your application for, and use of, the Company Services, or may obtain information about You from third parties. Such information may be stored, processed, transferred, and accessed by Company and its Affiliates, third parties, and service providers for business purposes, including for marketing, lead generation, service development and improvement, analytics, industry and market research, and such other purposes consistent with Company’s and its Affiliates’ legitimate business needs. You expressly consent to such use of personal data. </p>
                </div>
              </div>
              <h3>8. Insurance, Certificates and Licensing</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You agree to maintain during the term of this Agreement on all Vehicles operated by You under this Agreement automobile liability insurance that provides protection against bodily injury and property damage to third parties at levels of coverage that satisfy the minimum requirements to operate a private passenger or commercial vehicle, based on the type of vehicle You are using to perform Services on the public roads within the Territory. This coverage must also include any no-fault coverage required by law in the Territory that may not be waived by an insured. You agree to provide Company and its Affiliates a copy of the insurance policy, policy declarations, proof of insurance identification card and proof of premium payment for the insurance policy required in this Section 8.1 upon request. Furthermore, You must provide Company with written notice of cancellation of any insurance policy required by Company. Company shall have no right to control Your selection or maintenance of Your policy. You must be a named insured or individually rated driver, for which a premium is charged, on the insurance policy required in this Section 8.1 at all times. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> You agree to maintain during the term of this Agreement workers’ compensation insurance as required by all applicable laws in the Territory. If permitted by applicable law, You may choose to insure Yourself against industrial injuries by maintaining occupational accident insurance in place of workers’ compensation insurance. Furthermore, if permitted by applicable law, You may choose not to insure Yourself against industrial injuries at all, but do so at Your own risk. </b>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You understand and acknowledge that Your personal or commercial automobile insurance policy may not afford liability, comprehensive, collision, medical payments, personal injury protection, uninsured motorist, underinsured motorist, or other coverage for the Services You provide pursuant to this Agreement. If You have any questions or concerns about the scope or applicability of Your own insurance coverage, it is Your responsibility, not that of Company, to resolve them with Your insurer(s). The Company shall at no time be responsible to compensate You, Your representatives or employees or any User for any amounts not covered by Your insurance, the User’s insurance or any under or uninsured third-party. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.4</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Company may, but is not required to, maintain during the term of this Agreement insurance related to Your provision of Services as determined by Company in its reasonable discretion or as described in a City Addendum, provided that Company and its Affiliates are not required to provide You with any specific insurance coverage for any loss to You or Your Vehicle. You are required to promptly notify Company of any accidents that occur while providing Services and to cooperate and provide all necessary information related thereto. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.5</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Your territory may require You to obtain a business license in order to provide operate as an independent contractor to provide Services. In the event that You are required to establish a Sole Proprietorship, LLC or Corporation You are required to provide verification to the Company that You have a business license. You may not be eligible to accept trips using the App if you do not obtain any required business license. You are responsible for maintaining Your business license and for the costs associated with obtaining and maintaining the license. You may be required to obtain additional licensing or permits in order to legally provide Services; the Company shall not provide to You or assist You with obtaining any licensing or permits. The Company is not responsible for your failure to obtain any required licensing or permits. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">8.6</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Should You: fail to submit to the Company a change in Your address, driver’s license or Vehicle registration within 30 days after the date of the change; fail to immediately report to the Company any change in Your driving history or criminal history; refuse to authorize the Company to obtain and review an updated complete record of Your driving history not less than once each year and an investigation of Your criminal history not less than once every 3 years, Your use of the App will be barred and You shall not have authorization to provide Services. </p>
                </div>
              </div>
              <h3>9. Representations and Warranties; Disclaimers</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">9.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>By You.</b> You hereby represent and warrant that: (a) You have full power and authority to enter into this Agreement and perform Your obligations hereunder; (b) You have not entered into, and during the term will not enter into, any agreement that would prevent You from complying with this Agreement; and (c) You will comply with all applicable laws in Your performance of this Agreement, including holding and complying with all permits, licenses, registrations and other governmental authorizations necessary to provide (i) Services using the Vehicles pursuant to this Agreement, and (ii) Services to third parties in the Territory generally.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">9.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Disclaimer of Warranties.</b> COMPANY AND ITS AFFILIATES PROVIDE, AND YOU ACCEPT, THE COMPANY SERVICES, APP AND THE COMPANY DEVICES ON AN "AS IS" AND "AS AVAILABLE" BASIS. COMPANY AND ITS AFFILIATES DO NOT REPRESENT, WARRANT OR GUARANTEE THAT YOUR ACCESS TO OR USE OF THE COMPANY SERVICES, APP OR THE COMPANY DEVICES: (A) WILL BE UNINTERRUPTED OR ERROR FREE; OR (B) WILL RESULT IN ANY REQUESTS FOR SERVICES. COMPANY AND ITS AFFILIATES FUNCTION AS AN ON-DEMAND LEAD GENERATION TECHNOLOGY PLATFORM AND RELATED SERVICE ONLY AND MAKE NO REPRESENTATIONS, WARRANTIES OR GUARANTEES AS TO THE ACTIONS OR INACTIONS OF THE USERS WHO MAY REQUEST OR RECEIVE SERVICES FROM YOU, AND COMPANY AND ITS AFFILIATES DO NOT SCREEN OR OTHERWISE EVALUATE USERS. BY USING THE COMPANY SERVICES AND APP, YOU ACKNOWLEDGE AND AGREE THAT YOU MAY BE INTRODUCED TO A THIRD PARTY THAT MAY POSE HARM OR RISK TO YOU OR OTHER THIRD PARTIES. YOU ARE ADVISED TO TAKE REASONABLE PRECAUTIONS WITH RESPECT TO INTERACTIONS WITH THIRD PARTIES ENCOUNTERED IN CONNECTION WITH THE USE OF THE COMPANY SERVICES OR APP.NOTWITHSTANDING COMPANY’S APPOINTMENT AS THE LIMITED PAYMENT COLLECTION AGENT OF YOU FOR THE PURPOSE OF ACCEPTING PAYMENT FROM USERS ON YOUR BEHALF AS SET FORTH IN SECTION 4 ABOVE, COMPANY AND ITS AFFILIATES EXPRESSLY DISCLAIM ALL LIABILITY FOR ANY ACT OR OMISSION OF YOU, ANY USER OR OTHER THIRD PARTY.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">9.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>No Service Guarantee.</b> COMPANY AND ITS AFFILIATES DO NOT GUARANTEE THE AVAILABILITY OR UPTIME OF THE COMPANY SERVICES OR APP. YOU ACKNOWLEDGE AND AGREE THAT THE COMPANY SERVICES OR APP MAY BE UNAVAILABLE AT ANY TIME AND FOR ANY REASON (e.g., DUE TO SCHEDULED MAINTENANCE OR NETWORK FAILURE). FURTHER, THE COMPANY SERVICES OR APP MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN THE USE OF THE INTERNET AND ELECTRONIC COMMUNICATIONS, AND COMPANY AND ITS AFFILIATES ARE NOT RESPONSIBLE FOR ANY DELAYS, DELIVERY FAILURES, OR OTHER DAMAGES, LIABILITIES OR LOSSES RESULTING FROM SUCH PROBLEMS.
                  </p>
                </div>
              </div>
              <h3>10. Indemnification</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment"></span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You shall indemnify, defend (at Company’s option) and hold harmless Company and its Affiliates and their respective officers, directors, employees, agents, successors and assigns from and against any and all liabilities, expenses (including legal fees), damages, penalties, fines, social security contributions and taxes arising out of or related to: (a) Your breach of Your representations, warranties or obligations under this Agreement; or (b) any claim by a third party (including Users, regulators and governmental authorities) directly or indirectly related to Your provision of Services or use of the Company Services. This indemnification provision shall not apply to Your breach of any representations regarding Your status as an independent contractor. </p>
                </div>
              </div>
              <h3>11. Limits of Liability</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment"></span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> COMPANY AND ITS AFFILIATES SHALL NOT BE LIABLE UNDER OR RELATED TO THIS AGREEMENT FOR ANY OF THE FOLLOWING, WHETHER BASED ON CONTRACT, TORT OR ANY OTHER LEGAL THEORY, EVEN IF A PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES: (i) ANY INCIDENTAL, PUNITIVE, SPECIAL, EXEMPLARY, CONSEQUENTIAL, OR OTHER INDIRECT DAMAGES OF ANY TYPE OR KIND; OR (ii) YOUR OR ANY THIRD PARTY’S PROPERTY DAMAGE, OR LOSS OR INACCURACY OF DATA, OR LOSS OF BUSINESS, REVENUE, PROFITS, USE OR OTHER ECONOMIC ADVANTAGE. EXCEPT FOR COMPANY’S OBLIGATIONS TO PAY AMOUNTS DUE TO YOU PURSUANT TO SECTION 4 ABOVE, BUT SUBJECT TO ANY LIMITATIONS OR OTHER PROVISIONS CONTAINED IN THIS AGREEMENT WHICH ARE APPLICABLE THERETO, IN NO EVENT SHALL THE LIABILITY OF COMPANY OR ITS AFFILIATES UNDER THIS AGREEMENT EXCEED THE AMOUNT OF SERVICE FEES ACTUALLY PAID TO OR DUE TO COMPANY HEREUNDER IN THE SIX (6) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO SUCH CLAIM. </p>
                </div>
              </div>
              <h3>12. Term and Termination</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">12.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Term. </b>This Agreement shall commence on the date accepted by You and shall continue until terminated as set forth herein.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">12.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Termination. </b>Either party may terminate this Agreement: (a) without cause at any time upon seven (7) days prior written notice to the other party; (b) immediately, without notice, for the other party’s material breach of this Agreement; or (c) immediately, without notice, in the event of the insolvency or bankruptcy of the other party, or upon the other party’s filing or submission of request for suspension of payment (or similar action or event) against the terminating party. In addition, Company may terminate this Agreement or deactivate Your Driver ID immediately, without notice, with respect to You in the event You no longer qualify, under applicable law or the standards and policies of Company and its Affiliates, to provide Services or to operate the Vehicle, or as otherwise set forth in this Agreement.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">12.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Effect of Termination. </b>Upon termination of the Agreement, You shall: (a) promptly return to Company all Company Devices; and (b) immediately delete and fully remove the App from any of Your Devices. Outstanding payment obligations and Sections 1, 2.3, 2.5.3, 4, 5.3, 6, 7, 9, 10, 11, 12.3, 13, 14 and 15 shall survive the termination of this Agreement.
                  </p>
                </div>
              </div>
              <h3>13. Relationship of the Parties</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">13.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b> Except as otherwise expressly provided herein with respect to Company acting as the limited payment collection agent solely for the purpose of collecting payment from Users on Your behalf, the relationship between the parties under this Agreement is solely that of independent contracting parties. The parties expressly agree that: (a) this Agreement is not an employment agreement, nor does it create an employment relationship, between Company and You; and (b) no joint venture, partnership, or agency relationship exists between Company and You. </b>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">13.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> You have no authority to bind Company or its Affiliates and You undertake not to hold Yourself out as an employee, agent or authorized representative of Company or its Affiliates. Where, by implication of mandatory law or otherwise, You may be deemed an agent or representative of Company, You undertake and agree to indemnify, defend (at Company’s option) and hold Company and its Affiliates harmless from and against any claims by any person or entity based on such implied agency or representative relationship. </p>
                </div>
              </div>
              <h3>14. Miscellaneous Terms</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Modification.</b> In the event Company modifies the terms and conditions of this Agreement at any time, such modifications shall be binding on You only upon Your acceptance of the modified Agreement. Company reserves the right to modify any information referenced at hyperlinks from this Agreement from time to time. You hereby acknowledge and agree that, by using the Company Services, or downloading, installing or using the App, You are bound by any future amendments and additions to information referenced at hyperlinks herein, or documents incorporated herein, including with respect to Services Fee Calculations. Continued use of the Company Services or App after any such changes shall constitute Your consent to such changes. Unless changes are made to the arbitration provisions herein, You acknowledge and agree that modification of this Agreement does not create a renewed opportunity to opt out of arbitration.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Supplemental Terms.</b> Supplemental terms may apply to Your use of the Company Services, such as use policies or terms related to certain features and functionality, which may be modified from time to time (“Supplemental Terms”). You may be presented with certain Supplemental Terms from time to time. Supplemental Terms are in addition to, and shall be deemed a part of, this Agreement. Supplemental Terms shall prevail over this Agreement in the event of a conflict.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Severability.</b> If any provision of this Agreement is or becomes invalid or non-binding, the parties shall remain bound by all other provisions hereof. In that event, the parties shall replace the invalid or non-binding provision with provisions that are valid and binding and that have, to the greatest extent possible, a similar effect as the invalid or non-binding provision, given the contents and purpose of this Agreement.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.4</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Assignment.</b> You shall not assign or transfer this Agreement or any of its rights or obligations hereunder, in whole or in part, without the prior written consent of the Company. The Company may assign or transfer this Agreement or any or all of its rights or obligations under this Agreement from time to time without consent: (a) to an Affiliate; or (b) to an acquirer of all or substantially all of Company’s business, equity or assets.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.5</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>Entire Agreement.</b> This Agreement, including all Supplemental Terms, constitutes the entire agreement and understanding of the parties with respect to its subject matter and replaces and supersedes all prior or contemporaneous agreements or undertakings regarding such subject matter. In this Agreement, the words “including” and “include” mean “including, but not limited to.” The recitals form a part of this Agreement.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.6</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion">
                    <b>No Third Party Beneficiaries.</b> There are no third party beneficiaries to this Agreement, except as expressly set forth herein. Nothing contained in this Agreement is intended to or shall be interpreted to create any third-party beneficiary claims.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">14.7</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Notices. Any notice delivered by Company to You under this Agreement will be delivered by email to the email address associated with Your account or by posting on the portal available to You on the Company Services. Any notice delivered by You to Company under this Agreement will be delivered by contacting Company in the “Contact Us” section. Additional Territory-specific notices may be required from time to time. </p>
                </div>
              </div>
              <h3>15. Governing Law; Jurisdiction and Arbitration</h3>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">15.1</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> The interpretation of this Agreement shall be governed by the laws of the State of Nevada without regard to the choice or conflicts of law provisions of any jurisdiction. You hereby agree and consent to the personal and exclusive jurisdiction of the Courts of the County of Clark, State of Nevada as to all suits, actions and proceedings arising out of or relating to this Agreement and You further waive any claim that such suit, action or proceedings is brought in an improper or inconvenient forum. Any disputes, actions, claims or causes of action arising out of or in connection with this Agreement or the Company Services that are not subject to the arbitration clause contained in Section 15.3 shall be subject to the exclusive jurisdiction of the state and federal courts located in the City of Las Vegas, County of Clark, State of Nevada. However, neither the choice of law provision regarding the interpretation of this Agreement nor the forum selection provision is intended to create any other substantive right to non-Nevadans to assert claims under Nevada law whether that be by statute, common law, or otherwise. The failure of Company to enforce any right or provision in this Agreement shall not constitute a waiver of such right or provision unless acknowledged and agreed to by Company in writing. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">15.2</span>
                </div>
                <div className="col-md-11 col-10">
                  <p className="indentaion"> Other than disputes regarding the intellectual property rights of the parties and other claims identified in Section 15.3.ii, any disputes, actions, claims or causes of action arising out of or in connection with this Agreement or the Company Services shall be subject to arbitration pursuant to Section 15.3. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 col-1">
                  <span className="numbeagrment">15.3</span>
                </div>
                <div className="col-md-11 col-10">
                  <p style={{ fontSize: "17px" }} className="indentaion">
                    <ins>
                      <b>Arbitration Provision</b>
                    </ins>
                  </p>
                  <p>
                    <ins>Important Note Regarding this Arbitration Provision:</ins>
                  </p>
                  <ul>
                    <li>
                      <p> Except as provided below, arbitration does not limit or affect the legal claims You may bring against the Company. Agreeing to arbitration only affects where any such claims may be brought and how they will be resolved. </p>
                    </li>
                    <li>
                      <p> Arbitration is a process of private dispute resolution that does not involve the civil courts, a civil judge, or a jury. Instead, the parties’ dispute is decided by a private arbitrator selected by the parties using the process set forth herein. Other arbitration rules and procedures are also set forth herein. </p>
                    </li>
                    <li>
                      <p> Unless the law requires otherwise, as determined by the Arbitrator based upon the circumstances presented, You will be required to split the cost of any arbitration with the Company. </p>
                    </li>
                    <li>
                      <p> IMPORTANT: This Arbitration Provision will require You to resolve any claim that You may have against the Company or Company on an individual basis, except as provided below, pursuant to the terms of the Agreement unless You choose to opt out of the Arbitration Provision. Except as provided below, this provision will preclude You from bringing any class, collective, or representative action against the Company, and also precludes You from participating in or recovering relief under any current or future class, collective, or representative action brought against the Company or Company by someone else. </p>
                    </li>
                    <li>
                      <p> You (but not the Company) have the sole right to reject this arbitration provision as a means of resolving disputes with us at any time within thirty (30) days following your execution of this Agreement. To reject this arbitration provision you must give us written notice of your rejection of this arbitration provision by U.S. Mail, return receipt requested. Your notice to us opting out of this arbitration provision should include your name, address as well as a statement that you do not wish to resolve disputes with us through arbitration. You hereby agree and acknowledge that you may only opt out of this arbitration provision in the manner described above and it is not sufficient to notify us of your intent to opt out of this arbitration provision via telephone or any other means. You can only reject this arbitration provision until the thirtieth (30th) day following your signature on this Agreement; thereafter, you will be bound by the terms of this arbitration provision. </p>
                    </li>
                    <li>
                      <p>
                        <b> However, as discussed above and except as provided below, if You agree to arbitration, You will not be precluded from bringing Your claims against the Company or Company in an individual arbitration proceeding. If successful on such claims, You could be awarded money or other relief by an arbitrator (subject to splitting the cost of arbitration as mentioned above). </b>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <p className="pstep-from"> WHETHER TO AGREE TO ARBITRATION IS AN IMPORTANT BUSINESS DECISION. IT IS YOUR DECISION TO MAKE, AND YOU SHOULD NOT RELY SOLELY UPON THE INFORMATION PROVIDED IN THIS AGREEMENT AS IT IS NOT INTENDED TO CONTAIN A COMPLETE EXPLANATION OF THE CONSEQUENCES OF ARBITRATION. YOU SHOULD TAKE REASONABLE STEPS TO CONDUCT FURTHER RESEARCH AND TO CONSULT WITH OTHERS — INCLUDING BUT NOT LIMITED TO AN ATTORNEY — REGARDING THE CONSEQUENCES OF YOUR DECISION, JUST AS YOU WOULD WHEN MAKING ANY OTHER IMPORTANT BUSINESS OR LIFE DECISION. </p>
              <p className="pstep-from">
                <span>i. </span>&nbsp;&nbsp; <ins>How This Arbitration Provision Applies.</ins>
              </p>
              <p className="pstep-from"> This Arbitration Provision is governed by the Nevada Uniform Arbitration Act of 2000 (“NAA”). This Arbitration Provision applies to any dispute arising out of or related to this Agreement or termination of the Agreement and survives after the Agreement terminates. Nothing contained in this Arbitration Provision shall be construed to prevent or excuse You from utilizing any informal procedure for resolution of complaints established in this Agreement (if any), and this Arbitration Provision is not intended to be a substitute for the utilization of such procedures. If it is determined by a court of law that this provision cannot be arbitrated pursuant to the NAA then the Federal Arbitration Act, 9 U.S.C. § 1 et seq. (the “FAA”) shall govern. </p>
              <p className="pstep-from">
                <b> Except as it otherwise provides, this Arbitration Provision is intended to apply to the resolution of disputes that otherwise would be resolved in a court of law or before any forum other than arbitration, with the exception of proceedings that must be exhausted under applicable law before pursuing a claim in a court of law or in any forum other than arbitration. Except as it otherwise provides, this Arbitration Provision requires all such disputes to be resolved only by an arbitrator through final and binding arbitration on an individual basis only and not by way of court or jury trial, or by way of class, collective, or representative action. </b>
              </p>
              <p className="pstep-from"> Except as provided in Section 15.3(v), below, regarding the Class Action Waiver, such disputes include without limitation disputes arising out of or relating to interpretation or application of this Arbitration Provision, including the enforceability, revocability or validity of the Arbitration Provision or any portion of the Arbitration Provision. All such matters shall be decided by an Arbitrator and not by a court or judge. However, as set forth below, the preceding sentences shall not apply to disputes relating to the interpretation or application of the Class Action Waiver below, including their enforceability, revocability or validity. </p>
              <p className="pstep-from"> Except as it otherwise provides, this Arbitration Provision also applies, without limitation, to all disputes between You and the Company or Company, as well as all disputes between You and the Company’s or Company’s fiduciaries, administrators, affiliates, subsidiaries, parents, and all successors and assigns of any of them, including but not limited to any disputes arising out of or related to this Agreement and disputes arising out of or related to Your relationship with the Company, including termination of the relationship. This Arbitration Provision also applies, without limitation, to disputes regarding any city, county, state or federal wage-hour law, trade secrets, unfair competition, compensation, breaks and rest periods, expense reimbursement, termination, harassment and claims arising under the Uniform Trade Secrets Act, Civil Rights Act of 1964, Americans With Disabilities Act, Age Discrimination in Employment Act, Family Medical Leave Act, Fair Labor Standards Act, Employee Retirement Income Security Act (except for individual claims for employee benefits under any benefit plan sponsored by the Company and covered by the Employee Retirement Income Security Act of 1974 or funded by insurance), Genetic Information Non-Discrimination Act, and state statutes, if any, addressing the same or similar subject matters, and all other similar federal and state statutory and common law claims. </p>
              <p className="pstep-from"> This Agreement is intended to require arbitration of every claim or dispute that lawfully can be arbitrated, except for those claims and disputes which by the terms of this Agreement are expressly excluded from the Arbitration Provision. </p>
              <p className="pstep-from"> An arbitrator shall decide whether a condition precedent to arbitrability has been fulfilled and whether a contract containing a valid agreement to arbitrate is enforceable. If a party to a judicial proceeding challenges the existence of, or claims that a controversy is not subject to, an agreement to arbitrate, the arbitral proceeding may continue pending final resolution of the issue by the court, unless the court otherwise orders. </p>
              <p className="pstep-from">The disputes and claims set forth below shall not be subject to arbitration and the requirement to arbitrate set forth in this Arbitration Provision shall not apply:</p>
              <p className="pstep-from">Any action wherein a court of competent jurisdiction deems arbitration in inapplicable;</p>
              <p className="pstep-from">Claims for workers compensation, state disability insurance and unemployment insurance benefits;</p>
              <p className="pstep-from"> Regardless of any other terms of this Agreement, nothing prevents You from making a report to or filing a claim or charge with the Equal Employment Opportunity Commission, U.S. Department of Labor, Securities Exchange Commission, National Labor Relations Board, or Office of Federal Contract Compliance Programs, and nothing in this Agreement or Arbitration Provision prevents the investigation by a government agency of any report, claim or charge otherwise covered by this Arbitration Provision. Nothing in this Arbitration Provision shall be deemed to preclude or excuse a party from bringing an administrative claim before any agency in order to fulfill the party's obligation to exhaust administrative remedies before making a claim in arbitration; </p>
              <p className="pstep-from"> Disputes that may not be subject to a predispute arbitration agreement pursuant to applicable Federal law or Executive Order are excluded from the coverage of this Arbitration Provision; </p>
              <p className="pstep-from">Disputes regarding Your, the Company’s, or Company’s intellectual property rights;</p>
              <p className="pstep-from"> This Arbitration Provision shall not be construed to require the arbitration of any claims against a contractor that may not be the subject of a mandatory arbitration agreement as provided by section 8116 of the Department of Defense ("DoD") Appropriations Act for Fiscal Year 2010 (Pub. L. 111-118), section 8102 of the Department of Defense ("DoD") Appropriations Act for Fiscal Year 2011 (Pub. L. 112- 10, Division A), and their implementing regulations, or any successor DoD appropriations act addressing the arbitrability of claims. </p>
              <p className="pstep-from">
                <span>iii. </span> &nbsp;&nbsp; <ins>Selecting The Arbitrator and Location of the Arbitration.</ins>
              </p>
              <p className="pstep-from"> The Arbitrator shall be selected by mutual agreement of the Company and You. Unless You and the Company mutually agree otherwise, the Arbitrator shall be an attorney licensed to practice in the location where the arbitration proceeding will be conducted or an individual appointed by a court of law to render an award, alone or with others, in a controversy that is subject to an agreement to arbitrate. where the arbitration will be conducted. If the Parties cannot agree on an Arbitrator, then an arbitrator will be selected using the alternate strike method from a list of five (5) neutral arbitrators provided by JAMS (Judicial Arbitration & Mediation Services). You will have the option of making the first strike. If a JAMS arbitrator is used, then the JAMS Streamlined Arbitration Rules & Procedures rules will apply; however, if there is a conflict between the JAMS Rules and this Agreement, this Agreement shall govern. Those rules are available here:

              </p>
              <Link to="">http://www.jamsadr.com/rules-streamlined-arbitration/</Link>
              <p className="pstep-from"> The location of the arbitration proceeding shall be held in Clark County, Nevada, unless a court of law determines this provision to be unenforceable. If deemed unenforceable then the location of the arbitration shall be no more than 100 miles from the place where You last provided transportation services under this Agreement, unless each party to the arbitration agrees in writing otherwise. </p>
              <p className="pstep-from">
                <span>iv. </span>&nbsp;&nbsp; <ins>Starting The Arbitration.</ins>
              </p>
              <p className="pstep-from"> All claims in arbitration are subject to the same statutes of limitation that would apply in a Nevada court. The party bringing the claim must demand arbitration in writing and deliver the written demand by hand or first class mail to the other party within the applicable statute of limitations period. The demand for arbitration shall include identification of the Parties, a statement of the legal and factual basis of the claim(s), and a specification of the remedy sought. Any demand for arbitration made to the Company or Company shall be provided to Move It, LLC at _______________________________. The arbitrator shall resolve all disputes regarding the timeliness or propriety of the demand for arbitration. A party may apply to a court of competent jurisdiction for temporary or preliminary injunctive relief in connection with an arbitrable controversy, but only upon the ground that the award to which that party may be entitled may be rendered ineffectual without such provisional relief. </p>
              <p className="pstep-from">
                <span>v. </span> &nbsp;&nbsp; <ins>How Arbitration Proceedings Are Conducted.</ins>
              </p>
              <p className="pstep-from"> An arbitrator may conduct an arbitration in such manner as the arbitrator considers appropriate for a fair and expeditious disposition of the proceeding. The authority conferred upon the arbitrator includes the power to hold conferences with the parties to the arbitral proceeding before the hearing and, among other matters, determine the admissibility, relevance, materiality and weight of any evidence. An arbitrator may decide a request for summary disposition of a claim or particular issue: (a) If all interested parties agree; or (b) Upon request of one party to the arbitral proceeding if that party gives notice to all other parties to the proceeding, and the other parties have a reasonable opportunity to respond. If an arbitrator orders a hearing, the arbitrator shall set a time and place and give notice of the hearing not less than 5 days before the hearing begins. Unless a party to the arbitral proceeding makes an objection to lack or insufficiency of notice not later than the beginning of the hearing, the party’s appearance at the hearing waives the objection. Upon request of a party to the arbitral proceeding and for good cause shown, or upon the arbitrator’s own initiative, the arbitrator may adjourn the hearing from time to time as necessary but may not postpone the hearing to a time later than that fixed by the agreement to arbitrate for making the award unless the parties to the arbitral proceeding consent to a later date. The arbitrator may hear and decide the controversy upon the evidence produced although a party who was duly notified of the arbitral proceeding did not appear. The court, on request, may direct the arbitrator to conduct the hearing promptly and render a timely decision. At a hearing held under subsection 3, a party to the arbitral proceeding has a right to be heard, to present evidence material to the controversy and to cross-examine witnesses appearing at the hearing. If an arbitrator ceases or is unable to act during an arbitral proceeding, a replacement arbitrator must be appointed in accordance with NRS 38.226 to continue the proceeding and to resolve the controversy. </p>
              <p className="pstep-from"> An arbitrator may issue a subpoena for the attendance of a witness and for the production of records and other evidence at any hearing and may administer oaths. A subpoena must be served in the manner for service of subpoenas in a civil action and, upon motion to the court by a party to the arbitral proceeding or the arbitrator, enforced in the manner for enforcement of subpoenas in a civil action. To make the proceedings fair, expeditious and cost effective, upon request of a party to or a witness in an arbitral proceeding, an arbitrator may permit a deposition of any witness to be taken for use as evidence at the hearing, including a witness who cannot be subpoenaed for or is unable to attend a hearing. The arbitrator shall determine the conditions under which the deposition is taken. An arbitrator may permit such discovery as the arbitrator decides is appropriate in the circumstances, taking into account the needs of the parties to the arbitral proceeding and other affected persons and the desirability of making the proceeding fair, expeditious and cost effective. If an arbitrator permits discovery, the arbitrator may order a party to the arbitral proceeding to comply with the arbitrator’s orders related to discovery, issue subpoenas for the attendance of a witness and for the production of records and other evidence at a proceeding for discovery, and take action against a noncomplying party to the extent a court could if the controversy were the subject of a civil action in Nevada. An arbitrator may issue a protective order to prevent the disclosure of privileged information, confidential information, trade secrets and other information protected from disclosure to the extent a court could if the controversy were the subject of a civil action in Nevada. All laws compelling a person under subpoena to testify and all fees for attending a judicial proceeding, a deposition or a proceeding for discovery as a witness apply to an arbitral proceeding as if the controversy were the subject of a civil action in Nevada. The court may enforce a subpoena or order related to discovery for the attendance of a witness and for the production of records and other evidence. A subpoena or order related to discovery issued by an arbitrator in another state must be served in the manner provided by rule of court for service of subpoenas in a civil action in Nevada and, upon motion to the court by a party to the arbitral proceeding or the arbitrator, enforced in the manner provided by rule of court for enforcement of subpoenas in a civil action in Nevada. </p>
              <p className="pstep-from">
                <b> You and the Company agree to resolve any dispute that is in arbitration on an individual basis only, and not on a class, collective action, or representative basis (“Class Action Waiver”). The Arbitrator shall have no authority to consider or resolve any claim or issue any relief on any basis other than an individual basis. </b> The Arbitrator shall have no authority to consider or resolve any claim or issue any relief on a class, collective, or representative basis. Notwithstanding any other provision of this Agreement, the Arbitration Provision or the JAMS Streamlined Arbitration Rules & Procedures, disputes regarding the enforceability, revocability or validity of the Class Action Waiver may be resolved only by a civil court of competent jurisdiction and not by an arbitrator. In any case in which (1) the dispute is filed as a class, collective, or representative action and (2) there is a final judicial determination that all or part of the Class Action Waiver unenforceable, the class, collective, and/or representative action to that extent must be litigated in a civil court of competent jurisdiction, but the portion of the Class Action Waiver that is enforceable shall be enforced in arbitration.
              </p>
              <p className="pstep-from"> While the Company will not take any retaliatory action in response to any exercise of rights You may have under Section 7 of the National Labor Relations Act, if any, the Company shall not be precluded from moving to enforce its rights under the FAA to compel arbitration on the terms and conditions set forth in this Agreement. </p>
              <p className="pstep-from">
                <span>vi. </span> &nbsp;&nbsp; <ins>Paying For The Arbitration.</ins>
              </p>
              <p className="pstep-from"> Each party will pay the fees for his, her or its own attorneys, subject to any remedies to which that party may later be entitled under applicable law (i.e., a party prevails on a claim that provides for the award of reasonable attorney fees to the prevailing party). In all cases where required by law, the Company will pay the Arbitrator's and arbitration fees. If under applicable law the Company is not required to pay all of the Arbitrator’s and/or arbitration fees, such fee(s) will be apportioned equally between the Parties or as otherwise required by applicable law. However, You will not be required to bear any type of fee or expense that You would not be required to bear if You had filed the action in a court of law. Any disputes in that regard will be resolved by the Arbitrator as soon as practicable after the Arbitrator is selected, and Company shall bear all of the Arbitrator’s and arbitration fees until such time as the Arbitrator resolves any such dispute. </p>
              <p className="pstep-from">
                <span>vii. </span> &nbsp;&nbsp; <ins>The Arbitration Award.</ins>
              </p>
              <p className="pstep-from"> An arbitrator shall make a record of an award. The record must be signed or otherwise authenticated by an arbitrator who concurs with the award. The arbitrator or the arbitral organization shall give notice of the award, including a copy of the award, to each party to the arbitral proceeding. An award must be made within the time specified by the agreement to arbitrate or, if not specified therein, within the time ordered by the court. The court may extend or the parties to the arbitral proceeding may agree in a record to extend the time. The court or the parties may do so within or after the time specified or ordered. A party waives any objection that an award was not timely made unless the party gives notice of the objection to the arbitrator before receiving notice of the award. </p>
              <p className="pstep-from"> An arbitrator may award reasonable attorney’s fees and other reasonable expenses of arbitration if such an award is authorized by law in a civil action involving the same claim or by the agreement of the parties to the arbitral proceeding. As to all remedies other than attorney’s fees and costs, an arbitrator may order such remedies as the arbitrator considers just and appropriate under the circumstances of the arbitral proceeding. The fact that such a remedy could not or would not be granted by the court is not a ground for refusing to confirm an award or for vacating an award. An arbitrator’s expenses and fees, together with other expenses, must be paid as provided in the award. </p>
              <p className="pstep-from"> After a party to an arbitral proceeding receives notice of an award, the party may make a motion to the court for an order confirming the award at which time the court shall issue a confirming order unless the award is modified or corrected. Upon granting an order confirming, vacating without directing a rehearing, modifying or correcting an award, the court shall enter a judgment in conformity therewith. The judgment may be recorded, docketed and enforced as any other judgment in a civil action. A court may allow reasonable costs of the motion and subsequent judicial proceedings. </p>
              <p className="pstep-from">
                <span>viii. </span> &nbsp;&nbsp; <ins>
                  <b>Your Right To Opt Out Of Arbitration.</b>
                </ins>
              </p>
              <p className="pstep-from">
                <b> Arbitration is not a mandatory condition of Your contractual relationship with the Company. If You do not want to be subject to this Arbitration Provision, You may opt out of this Arbitration Provision by notifying the Company in writing of Your desire to opt out of this Arbitration Provision, either by (1) sending, within 30 days of the date this Agreement is executed by You, electronic mail to (email), stating Your name and intent to opt out of the Arbitration Provision or (2) by sending a letter by U.S. Mail, or by any nationally recognized delivery service (e.g, UPS, Federal Express, etc.), or by hand delivery to: </b>
              </p>
              <p className="pstep-from">
                <b>Move It LLC</b>
              </p>
              <p className="pstep-from">
                <b>_________________</b>
              </p>
              <p className="pstep-from">
                <b>_________________</b>
              </p>
              <p className="pstep-from">
                <b> In order to be effective, the letter under option (2) must clearly indicate Your intent to opt out of this Arbitration Provision, and must be dated and signed. The envelope containing the signed letter must be received (if delivered by hand) or post-marked within 30 days of the date this Agreement is executed by You. Your writing opting out of this Arbitration Provision, whether sent by (1) or (2), will be filed with a copy of this Agreement and maintained by the Company. Should You not opt out of this Arbitration Provision within the 30-day period, You and the Company shall be bound by the terms of this Arbitration Provision. You have the right to consult with counsel of Your choice concerning this Arbitration Provision. You understand that You will not be subject to retaliation if You exercise Your right to assert claims or opt-out of coverage under this Arbitration Provision. </b>
              </p>
              <p className="pstep-from">
                <b> BY ENTERING YOUR NAME AND ADDRESS BELOW, YOU EXPRESSLY ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND TAKEN STEPS TO THOUGHTFULLY CONSIDER THE CONSEQUENCES OF THIS ARBITRATION AGREEMENT, THAT YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS OF THE ARBITRATION AGREEMENT, AND THAT YOU ARE LEGALLY COMPETENT TO ENTER INTO THE ARBITRATION AGREEMENT WITH COMPANY. </b>
              </p>
              <p className="pstep-from">
                <b>Signed: ____________________________, this ___ day of ______, 20__.</b>
              </p>
              <p className="pstep-from">
                <b> I, ______________ (NAME) OF _______________________________________(ADDRESS), DO HEREBY ACKNOWLEDGE THAT I HAVE READ THIS ARBITRATION AGREEMENT AND AFFIRMATIVELY AGREED TO AND GIVE THIS SPECIFIC AUTHORIZATION TO SUBMIT TO ARBITRATION ANY DISPUTE ARISING BETWEEN THE PARTIES TO THIS AGREEMENT, THAT I AM BOUND TO THE SAME. </b>
              </p>
              <p className="pstep-from">
                <span>ix. </span> &nbsp;&nbsp; <ins>Full and Complete Agreement Related to Formal Resolution of Disputes; Enforcement Of This Agreement.</ins>
              </p>
              <p className="pstep-from"> This Arbitration Provision is the full and complete agreement relating to the formal resolution of disputes arising out of this Agreement. Except as stated in subsection v, above, in the event any portion of this Arbitration Provision is deemed unenforceable, the remainder of this Arbitration Provision will be enforceable. </p>
              <p className="pstep-from"> By checking below, You fully understand you are an independent enterprise which is required to maintain your own insurance and are not eligible for workers compensation benefits. </p>
              <p className="pstep-from"> By checking below, You expressly acknowledge You are liable for any damage to a person’s property and not limited to items being picked up, delivered, moved, transported to any destination. </p>
              <p className="pstep-from">By checking below, You expressly acknowledge Move It is not your employer. You acknowledge You are economically independent from Move It.</p>
              <p className="pstep-from"> By checking accept below, You expressly acknowledge that You have read, understood, and taken steps to thoughtfully consider the consequences of this Agreement, that You agree to be bound by the terms and conditions of the Agreement, and that You are legally competent to enter into this Agreement with Company. </p>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation140"   {...formik.getFieldProps("first_value")} checked={formik.values.first_value} />
                <label className="custom-control-label" htmlFor="customControlValidation140"> This Arbitration Provision is the full and complete agreement relating to the formal resolution of disputes arising out of this Agreement. Except as stated in subsection v, above, in the event any portion of this Arbitration Provision is deemed unenforceable, the remainder of this Arbitration Provision will be enforceable. </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation141" {...formik.getFieldProps("second_value")} checked={formik.values.second_value} />
                <label className="custom-control-label" htmlFor="customControlValidation141"> By checking, You fully understand you are an independent enterprise which is required to maintain your own insurance and are not eligible for workers compensation benefits. </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation142" {...formik.getFieldProps("third_value")} checked={formik.values.third_value} />
                <label className="custom-control-label" htmlFor="customControlValidation142"> By checking, You expressly acknowledge You are liable for any damage to a person’s property and not limited to items being picked up, delivered, moved, transported to any destination. </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation143" {...formik.getFieldProps("fourth_value")} checked={formik.values.fourth_value} />
                <label className="custom-control-label" htmlFor="customControlValidation143"> By checking, You expressly acknowledge Move It is not your employer. You acknowledge You are economically independent from Move It. </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation144"  {...formik.getFieldProps("fifth_value")} checked={formik.values.fifth_value} />
                <label className="custom-control-label" htmlFor="customControlValidation144"> By checking, You expressly acknowledge that You have read, understood, and taken steps to thoughtfully consider the consequences of this Agreement, that You agree to be bound by the terms and conditions of the Agreement, and that You are legally competent to enter into this Agreement with Company. </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 insurancecheck">
            <div className="form-group check-group">
              <div className="custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="customControlValidation145" {...formik.getFieldProps("six_value")} checked={formik.values.six_value} />
                <label className="custom-control-label" htmlFor="customControlValidation145"> Agreeing to this contract allows Move It, LLC to perform background check on me.</label>
              </div>
            </div>
          </div>
          {(formik.touched.first_value && formik.errors.first_value) || (formik.touched.second_value && formik.errors.second_value) || (formik.touched.third_value && formik.errors.third_value) || (formik.touched.fourth_value && formik.errors.fourth_value) || (formik.touched.fifth_value && formik.errors.fifth_value) || (formik.touched.six_value && formik.errors.six_value) ? <div className="col-12 col-md-12 col-lg-10 text-danger">Please agree to all helper agreement check.</div> : ''}
        </div>
        <div className="row">
          <div className="col-md-12">
            <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
              <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
            <button className="btn step-btn" type="submit" > <span>I Agree & Continue</span> </button>
          </div>
        </div>
      </form>
    </div>

  )
}


const StepSeven = (props) => {
  useEffect(() => {
    setImageBase64()
  }, [])

  const formik = useFormik({
    initialValues: props.data,
    validationSchema: yup.object({
      helper_signature: yup.string().required('Please add signature.'),
      security_key: yup.number().typeError('You must specify a number.').required('Please enter the social security number.')
    }),
    onSubmit: values => {
      props.next(values, true);
    }
  });

  const clearSignature = () => {
    formik.setFieldValue('helper_signature', '');
    sigCanvas.clear();
  }

  const getImageValue = () => {
    formik.setFieldValue('helper_signature', sigCanvas.getTrimmedCanvas().toDataURL('image/png'));
  }

  const setImageBase64 = () => {
    if (props.data.helper_signature) {
      sigCanvas.fromDataURL(props.data.helper_signature);
    }
  }
  return (

    <div className="form-steps" style={{ display: "block" }}>
      <form action="#" className="job-application-form" onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="login-page row">
          <div className="col-md-12 col-lg-12 mb-2">
            <p className="mtb-0">Move It needs Social Security Numbers for all Independent contractors.</p>
          </div>
          <div className="form-row col-md-6 col-lg-6">
            <i className="fas fa-shield fa-fw"></i>
            <input type="text"  {...formik.getFieldProps("security_key")} />
            <span>Social Security Number</span>
            {formik.touched.security_key && formik.errors.security_key ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.security_key}</div> : ''}
          </div>
          <div className="col-md-12 col-lg-12 mb-2">
            <p className="mb-2">
              IRS Form W-9 is most commonly used by individuals when they are working as a freelancer or independent contractors. If you ever find your self filling out a Form W-9 It generally means that a
              business or person who is paying you money needs your Social Security Number so It can notify the IRS of the amount.
            </p>
            <p className="mb-2">Your Information will NEVER be shared, sold or given to ANYONE.</p>
          </div>

          <div className="col-md-12 col-lg-12 mb-2">
            <h5>Draw Your Signature</h5>
            <div className="box-signture" style={{ padding: "unset" }}>
              <SignatureCanvas canvasProps={{ className: 'sigCanvas' }} ref={(ref) => { sigCanvas = ref }} onEnd={() => getImageValue()} />
              <button className="btn step-btn mb-3 rbntclear" type="button" onClick={() => clearSignature()} ><span>Clear</span></button>
            </div>

            {formik.touched.helper_signature && formik.errors.helper_signature ? <div className="col-12 col-md-12 col-lg-10 text-danger">{formik.errors.helper_signature}</div> : ''}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
              <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
            <button className="btn step-btn" type="submit" ><span>Continue</span></button>
          </div>
        </div>
      </form>
    </div>

  )
}

const StepEight = (props) => {

  return (
    <div className="form-steps" style={{ display: "block" }}>
      <div className="form-card-verifycation tablemotop">
        <div className="col-12 col-sm-12 mb-5">
          <h2 className="fs-title text-center mb-0">Pending Verification</h2>
          <img alt="" src="web/img/pending_verification_icon.png" className="imgpnd" />
          <h4 className="text-center">Your W-9 form verification process is under review by admin. It will take 3-7 Days to verify your details.</h4>
          <p className="text-center">You must complete app demo/tutorial.</p>
          <p className="text-center"><button type="button" className="accpet-helpebtn">Back To Home</button></p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Link to="" className="prev prev-btn-bokmove prev-btn" onClick={() => props.prev(props.data)}>
            <span><i className="fa fa-arrow-left"></i>Previous</span></Link>
          <button className="btn step-btn" type="button" ><span>Continue</span></button>
        </div>
      </div>
    </div>
  )
}
export default RegisterB;